/* eslint-disable eqeqeq */
/* eslint-disable no-array-constructor */

import {saveData, getReportType, hasReportLogo, getFlow, getFlowImgs, getLogImg, getMainData, getAddressOptions, getDicData, getOrgList, getConfigInfo, getSqlDicData, getDataByApi, getReport, getGridData} from '@/api/form-render';
import {getTempShareLookSimpleUrl,getTempShareLookUrl,getFileShareLookUrl} from "../../../api/attachment";
import {mapGetters, mapMutations} from 'vuex';
import {getOrgCorpInfo} from '@/api/corp';
import {API_RUN_TYPE, EVENT_TYPE} from '../../../public/js/const';
import webapp from '../../../sys/report/grwebapp.js';
import utils from '../../../sys/report//utils.js';
import excel from '@/utils/excel';
import {FUN_DATA, funUtil} from '../util';
import {getUUID} from '../../../utils/uuid';
import {deleteData} from '../../../api/workflow';
// import {formUtil} from '../form'
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"],
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ direction: "rtl" }],
  [{ size: ["small", false, "large", "huge"] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }],
  [{ font: [] }],
  [{ align: [] }],
  ["link", "image"],
  ["clean"]
];
var extendFun = undefined;
export const mixin = {
  data () {
    let _this = this;
    return {
      transferCopy: false, // 转阅，创建人和管理员有权限转阅
      transferCopyVisible:false,
      rollbackDataBtnVisible: false, // 反核销
      formDialogVisible: false, // 穿透表单
      formKey: '',
      formId: '',
      formInfoId: '',
      businessKey: '',
      subFormCount: 0,
      subForms: [], // 明细表
      tableName: '', // 数据库表
      entityId: '', // 实体
      activeTab: 'subForm1',
      ruleComputeData: {}, // 数据来源为字符串拼接
      apiSourceData: {}, // 主表是关联接口， key为触发字段，value为接口信息列表，有可能一个字段影响多个接口
      sourceFileData: {}, // 关联附件
      sourceData: {}, // 主表数据来源 ，key为字段columnName
      subFormSummary: {}, // 主表需要关联明细表合计
      selectFormKey: '', // 弹框选择，关联表单的formKey
      selectFormReadOnly: true, // 弹框选择，是否允许编辑
      selectFormTitle: '', // 弹框选择，表单title
      selectFormConfig: {}, // 选择弹出框的配置
      rules: {}, // 表单校验
      loadCount: 0, // 加载数据的计数器
      mainData: {},
      formRows: [],
      selectFormQueryParams: null, // 选择弹框表单时查询传参，默认把表单数据传过去
      fileColumns: [], // 附件列
      hiddenColumns: [], // 隐藏字段
      formSelectBindColumn: '', // 表单弹框之后的赋值字段
      formColumnTitleMap: {}, // 保存主表所有字段中文对应的columnName
      formColumnsMap: {}, // 保存主表所有字段 ，key为字段columnName
      formColumns: [],
      selectFormVisible: false, // 弹框选择树表
      subFormsVisible: false, // 显示明细表
      processMonitorVisible: false, // 显示流程记录
      ifFormEditRender: false, // 是否表单编辑时第一次渲染
      selectProjMemberModels: { // 选部门组件
        isShow: false,
        selectList: [],
        callBack: this.projMemberCallBack,
        radioSelectFlags: false
      },
      selectMemberModels: {// 人员控件
        form: {},
        isShow: false,
        selectList: [],
        callBack: this.memberCallBack,
        radioSelectFlags: false
      },
      selectRoleModels: {// 角色控件
        isShow: false,
        selectList: [],
        callBack: this.selectRoleCallBack,
        radioSelectFlags: false
      },
      codeColumnNames:[], //单号列
      showTips: false,
      disabled: false, // 如果为true流程也不能提交，不能加载
      readOnly: false,
      checkList: [],
      selectQuertersModels: {// 部门控件
        isShow: false,
        form: {},
        selectList: [],
        callBack: this.quertersCallBack,
        radioSelectFlags: false
      },
      wfFormAuth: null, // 流程过程中字段权限
      showConditionData: {}, // 字段显示条件数据，优先级最高，超过流程过程控制
      showConditionColumns:[],
      authsMap: {},
      ifCopy: false, // 流程过程中字段权限判断使用
      defaultPic: require('../../../assets/img/defaut.jpg'),
      ifHasProcess: false, // 是否含有流程
      processForm: undefined, // 流程处理单
      processModel: null, //  流程模型
      processFormVisible: false, // 流程提交处理单
      defaultConfig: {},
      dicData: {}, // 数据字典数据
      dicLoaded: {}, // 标记是否数据字典请求后台加载完成
      loading: false,
      html5Params: {},
      selectModalVisible: false,
      modalList: [],
      userList: [],
      modal: {},
      subList: [],
      ImageList: [],
      logoData: '',
      fullEditor: null,
      fullEditorSelection: null,
      fullEditorImagesVisible: false, // 富文本图片管理
      fullEditorImageUpload:{
        limit: 20,
        limitSize: 1048577,
        readOnly: false,
        xtype: 'full-editor',
        autoLoad:true,
        accept: '.jpg,.JPG,.png,.PNG,.jpeg,.JPEG',
        acceptMsg: '只能传图片格式文件'
      },
      readLikeVisible:false,// 是否显示已阅点赞
      readLikeFormInfoId: null,
      editorOption: {
        /*modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
            ['blockquote', 'code-block']
          ]
        }*/
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              'link': function(value) {

                //console.log('----link-----',value);
                if (value) {
                  var href = prompt('Enter the URL');
                  this.quill.format('link', href);
                } else {
                  this.quill.format('link', false);
                }
              },
              // handlers object will be merged with default handlers object
              'image': function (value) {
                let selection = this.quill.getSelection();

                //console.log('----image-----'+value,selection,this,_this);
                _this.fullEditorSelection = selection;
                _this.fullEditor = this;
                _this.fullEditorImagesVisible = true;
                this.quill.format("image", false);
              }
            }
          }
        }
      },
      selectExcelVisible: false,
      excelList: [],
      uploadLoading: false,
      file: null,
      squareLogo: '',
      grfType: false, // 默认没有配置报表
      uploadConfig: {
        limit: 10,
        limitSize: 50048576,
        // listType: 'picture-card',
        readOnly: false,
        xtype: 'test',
        accept: '.xlsx,.xls',
        acceptMsg: '只能传xls/xlsx格式文件'
      },
      excelData: [],
      excelModal: null,
      signData: null,
      wfData: null,
      flowData: {}, // 流程数据
      flowList: [],
      addressObj: {addressVisible: false}, // 地图选择
      clickCloumn: {},
      timer: null,
      cascaderOptions:[
        {
          value: '暂无',
          label: '暂无',
        },
        {
          value: '地质条件风险',
          label: '地质条件风险',
          children:[
            {value:"填海",label: '填海'},
            {value:"湿地",label: '湿地'},
            {value:"溶洞",label: '溶洞'},
            {value:"冻土",label: '冻土'}
          ]
        },
        {
          value: '政府要求风险',
          label: '政府要求风险',
          children:[
            {value:"品牌限定",label: '品牌限定'},
            {value:"扬尘管控",label: '扬尘管控'},
            {value:"环保施工",label: '环保施工'},
            {value:"车辆限行",label: '车辆限行'},
            {value:"外墙材料限制",label: '外墙材料限制'},
            {value:"联合验收在前",label: '联合验收在前'},
            {value:"疫情管控",label: '疫情管控'},
          ]
        },
        {
          value: '天气及气候风险',
          label: '天气及气候风险',
          children:[
            {value:"冬歇期",label: '冬歇期'},
            {value:"梅雨季",label: '梅雨季'},
            {value:"台风季",label: '台风季'},
            {value:"雨雪",label: '雨雪'},
            {value:"干旱",label: '干旱'},
            {value:"洪水",label: '洪水'},
            {value:"高温",label: '高温'},
          ]
        },
        {
          value: '重大官方活动或特殊事件风险',
          label: '重大官方活动或特殊事件风险',
          children:[
            {value:"大型赛事",label: '大型赛事'},
            {value:"大型政治活动",label: '大型政治活动'},
            {value:"每年两会",label: '每年两会'},
            {value:"中、高考",label: '中、高考'},
          ]
        },
        {
          value: '节假日风险',
          label: '节假日风险',
          children:[
            {value:"春节讨薪",label: '春节讨薪'},
            {value:"清明",label: '清明'},
            {value:"618临场交付",label: '618临场交付'},
            {value:"双11临场交付",label: '双11临场交付'},
            {value:"国庆长假",label: '国庆长假'}
          ]
        },
        {
          value: '地方风俗风险',
          label: '地方风俗风险',
          children:[
            {value:"农忙",label: '农忙'},
            {value:"少数民族节日",label: '少数民族节日'},
            {value:"开学季",label: '开学季'}
          ]
        },
        {
          value: '施工现场安全风险',
          label: '施工现场安全风险',
          children:[
            {value:"临时堆场",label: '临时堆场'},
            {value:"运输道路",label: '运输道路'},
            {value:"安全交底",label: '安全交底'},
            {value:"成品保护",label: '成品保护'},
          ]
        },
        {
          value: '危险性大工程风险',
          label: '危险性大工程风险',
          children:[
            {value:"深基坑",label: '深基坑'},
            {value:"高支模",label: '高支模'},
            {value:"装卸能力",label: '装卸能力'},
            {value:"操作人员配备",label: '操作人员配备'}
          ]
        },
        {
          value: '竣工验收风险',
          label: '竣工验收风险',
          children:[
            {value:"新增政府规定",label: '新增政府规定'},
            {value:"备品备件",label: '备品备件'}
          ]
        },
      ]
    };
  },
  props: {
    openConfig: { // 列表或者按钮或者传统触发弹框打开页面时使永
      type: Object,
      default: function () {
        return undefined;
      }
    },
    config: {
      type: Object,
      default: function () {
        return {columns: []};
      }
    }
  },
  beforeDestroy () {
    // 销毁前关闭定时器
    clearInterval(this.timer);
  },
  mounted () {
    let vm = this;
    this.transferCopy = false;
    this.transferCopyVisible = false;
    this.rollbackDataBtnVisible = false;
    this.ifCopy = false;
    this.rules = {};
    this.keyword = '';
    this.subForms = [];
    this.mainData = {};
    this.dicLoaded = {};
    this.gridData = [];
    this.pageSize = 30;
    this.pageCount = 0;
    this.pageIndex = 1;
    this.totalCount = 0;
    this.formKey = '';
    this.businessKey = '';
    this.selectFormKey = '';
    this.selectFormReadOnly = true;
    this.formRows = [];
    this.searchFormColumns = [];
    this.subFormsVisible = false;
    this.selectFormVisible = false;
    this.formSelectBindColumn = '';
    this.fileColumns = []; // 附件列
    this.hiddenColumns = [];
    this.selectFormConfig = {};
    this.subFormSummary = {};
    this.formColumnsMap = {};
    this.sourceData = {};
    this.tableName = '';
    this.entities = '';
    this.readOnly = false;
    this.ifHasProcess = false;
    this.processForm = undefined;
    this.processModel = null;
    this.processFormVisible = false;
    this.selectFormQueryParams = null;
    this.subFormCount = 0;
    this.apiSourceData = {};
    this.formColumnTitleMap = {};
    this.ruleComputeData = {};
    this.wfFormAuth = null;
    this.ifFormEditRender = false;
    this.sourceFileData = {};
    this.authsMap = {};
    this.showConditionData = {};
    this.showConditionColumns = [];
    this.signData = {};
    this.wfData = [];
    this.showTips = false;
    this.readLikeVisible = false;
    this.readLikeFormInfoId = null;
    this.codeColumnNames = [];
    this.init();
    // 获取是否携带公司logo
    hasReportLogo(this).then(res => {
      let hasLogo = res.data == '1';
      if (hasLogo) {
        getOrgCorpInfo(this.sessionUtil.getCompanyUid()).then(data => {
          this.squareLogo = data.squareLogo;
        });
      }
    });
    // this.timer = setInterval(() => {
    //   this.cookieUtil.set(vm.$route.path, JSON.stringify(vm.mainData), 3600000)
    // }, 1000)
    // webapp.webapp_urlprotocol_startup()
  },
  computed: {
    ...mapGetters([
      'getFormConfig',
      'formSelectData'
    ]),
    emptyText(){
      return function (column) {
        let codeColumnNames = this.codeColumnNames || [];
        // console.log(column.columnName+'-----emptyText----',codeColumnNames,this);
        if(this.validUtil.isNotNull(column.emptyText)){
          return column.emptyText;
        }else{
          let widgetType = column.widgetType;
          if(column.widgetType){
            if(widgetType === 'select' || widgetType === 'select-dic' || widgetType === 'select-sql'
              || widgetType === 'select-form' || widgetType === 'open-form' || widgetType === 'select-map-point'
            ){
              return '请选择'+column.title;
            }else if(column.columnName && codeColumnNames.indexOf(column.columnName)>-1){
              // 如果是单号
              return '保存后自动生成';
            }
          }
        }
        return '请填写'+column.title;

      };
    },
    // 判断字段是否显示
    formColumnHidden () {
      return function (column) {
        // console.log(column.columnName+'----formColumnHidden--'+column.title+'--',this.showConditionData[column.columnName],this.showConditionData);
        // 优先隐藏条件
        if (this.showConditionData && this.showConditionData[column.columnName] != undefined) {
          // console.log('---------'+column.columnName+'---------'+this.showConditionData[column.columnName])
          if (this.showConditionData[column.columnName] == false) {
            return true;
          } else {
            return false;
          }
        }
        // console.log(column.columnName+'-----1-----',this.authsMap[this.formInfoId] )
        // 优先判断流程配置权限
        if (this.authsMap && this.authsMap[this.formInfoId]) {
          if (this.authsMap[this.formInfoId][column.columnName]) {
            // console.log(column.columnName+'-----2-----',this.authsMap[this.formInfoId][column.columnName])
            if (this.authsMap[this.formInfoId][column.columnName] == 1) {
              return false;
            } if (this.authsMap[this.formInfoId][column.columnName] == 2) {
              return false;
            } else if (this.authsMap[this.formInfoId][column.columnName] == 3) {
              return true;
            } else if (this.authsMap[this.formInfoId][column.columnName] == 4) {
              return false;
            }
          }
        }
        if (column.hidden === 1) {
          return true;
        }
        // 过滤权限
        return column.btnLook == 0;
        // return false
      };
    },
    formColumnReadOnly () {
      return function (column) {
        // console.log(column.columnName+'-----formColumnReadOnly------',this.readOnly,this.disabled, column.readOnly,column.btnEdit)

        if (this.authsMap && this.authsMap[this.formInfoId] && this.authsMap[this.formInfoId][column.columnName] === 1) {
          return false;
        }
        if (this.authsMap && this.authsMap[this.formInfoId] && this.authsMap[this.formInfoId][column.columnName] === 4) {
          return false;
        }
        if (this.authsMap && this.authsMap[this.formInfoId] && this.authsMap[this.formInfoId][column.columnName] === 2) {
          return true;
        }
        // 优先判断流程
        if (column.status) {
          if (column.btnEdit == 0) {
            return true;
          } else {
            return false;
          }
        }
        // console.log(column.title+'----------',this.readOnly ,this.disabled,this.mainData['PROC_STATUS_'])
        // 过滤权限
        if (this.readOnly || this.disabled || column.btnEdit == 0) {
          return true;
        }
        // if (this.readOnly) {
        //   return true
        // }
        // 如果流程状态为以审 则设置为只读
        if (this.mainData['PROC_STATUS_'] == -5) {
          // this.readOnly = true;
          return true;
        }
        return column.readOnly == undefined ? false : column.readOnly === 1;
      };
    },
    computeReadOnly () {
      return function () {
        if (this.disabled) {
          return true;
        } else {
          if (this.readOnly) {
            return true;
          }
        }
        return false;
      };
    },
    computePicView (column) {
      return function (column) {
        let defaultUrl = this.defaultPic;// 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg'
        if (this.mainData[column.columnName]) {
          defaultUrl = this.util.getBaseUrl() + '/api_v1/files/' + this.mainData[column.columnName] + '/look?ifThumb=' + column.ifThumb + '&access_token=' + this.sessionUtil.getAccessToken();
        }
        return defaultUrl;
      };
    },
    formatDate () {
      return function (column, value) {
        let format = 'yyyy-MM-dd';
        if (column.widgetType === 'select-time') {
          format = 'HH:mm:ss';
        } else if (column.widgetType === 'select-date-time') {
          format = 'yyyy-MM-dd hh:mm:ss';
        }
        // console.log('-----formatDate-------',value,typeof value, format)
        if (typeof value === 'object') {
          return value.format(format);
        } if (typeof value === 'number') {
          let date = new Date(value);
          return date.format(format);
        } else if (typeof value === 'string') {
          if (value.indexOf('T') > -1) {
            return value.substring(0, 10);
          } else {
            try {
              if (value.indexOf(':') > -1) {
                return value;
              } else {
                let num = Number(value);
                let date = new Date(num);
                return date.format(format);
              }
            } catch (e) {
              return value;
            }
          }
        }
      };
    }
  },
  watch: {
  },
  methods: {
    ...mapMutations([
      'setFormConfig',
      'setFormSelectData'
    ]),
    handleRiskChange(value){
      console.log("value==级联值好=====>",value);
    },
    init () {
      this.loading = true;
      let formKey = null;
      let formInfoId = null;
      // 判断是否props属性弹框传参
      if (this.openConfig && this.openConfig.formKey) {
        formKey = this.openConfig.formKey;
        if (this.openConfig.disabled != undefined) {
          this.readOnly = this.openConfig.disabled;
          this.disabled = this.openConfig.disabled;
          // console.info('-----this.readOnly -------'+this.readOnly )
        }
        if(this.validUtil.isNotNull(this.openConfig.formInfoId)){
          formInfoId = this.openConfig.formInfoId;
        }
      } else {
        formKey = this.$route.params.formKey;
      }
      // 判断路由是否传入formKey
      // console.info('--form-edit---formKey-----'+formKey)
      this.processModel = {};
      this.processModel.parent = this;
      this.processModel.ifHasProcess = false;
      if (this.validUtil.isNotNull(formKey)) {
        let config = {};
        let params = {};
        params['formKey'] = formKey;
        if (this.validUtil.isNotEmpty(this.util.getUrlParam('_procDefId'))) {
          params.procDefId = this.util.getUrlParam('_procDefId');
        }
        if (this.validUtil.isNotEmpty(this.util.getUrlParam('_currentActId'))) {
          params.actId = this.util.getUrlParam('_currentActId');
        }
        if (this.validUtil.isNotEmpty(this.util.getUrlParam('_taskType'))) {
          let taskType = this.util.getUrlParam('_taskType');
          if (taskType == '1') {
            this.ifCopy = true;
          }
        }

        // 获取表单配置，获取这个表单有哪些字段
        getConfigInfo(params, this).then(data => {
          for (var key in data) {
            config[key] = data[key];
          }
          // config.forms 拿到的就是表单有哪些字段和字段的配置
          // defaultConfig === configuration.forms
          // 判断是否多表单，如果是则先判断enabelProcess
          if (config.forms.length > 1) {
            let form ;
            if(this.validUtil.isNotNull(formInfoId)){
              form = config.forms.find(item => {
                return item.id === formInfoId;
              });
            }else{
              form = config.forms.find(item => {
                return item.enableProcess && item.enableProcess === 1;
              });
            }
            if (form) {
              this.defaultConfig = form;
            } else {
              this.defaultConfig = config.forms[config.forms.length - 1];
            }

          } else {
            if (config.forms[config.forms.length - 1]) {
              this.defaultConfig = config.forms[config.forms.length - 1];
            }
          }
          this.defaultConfig.ifHasProcess = config.ifHasProcess;
          this.defaultConfig.formKey = formKey;
          this.wfFormAuth = config.wfFormAuth; // 获取流程过程节点权限
          this.formKey = formKey;
          // 先判断是否弹框打开表单
          if (this.openConfig && this.openConfig.formKey) {
            this.defaultConfig.businessKey = this.openConfig.businessKey ? this.openConfig.businessKey : '';
            this.defaultConfig.parent = this.openConfig.parent;
            this.defaultConfig.initValues = this.openConfig.initValues && this.config.initValues ? Object.assign(this.openConfig.initValues, this.config.initValues) : (this.openConfig.initValues || this.config.initValues);
            // console.info(this.openConfig)
            if (this.openConfig.parentSelectedData) {
              this.defaultConfig.parentSelectedData = this.openConfig.parentSelectedData;
            }
          } else {
            // 从路由中获取业务数据id
            this.defaultConfig.businessKey = this.$route.params.businessKey ? this.$route.params.businessKey : this.$route.query.id;
            this.disabled = this.$route.params.disabled || this.$route.query.disabled || false;
            this.readOnly = this.$route.params.readOnly || this.$route.query.readOnly || false;
          }
          this.formId = this.defaultConfig.formId;
          this.formInfoId = this.defaultConfig.id;
          // console.log('-----1----this.disabled---------',this.disabled,this.readOnly,this.$route);
          // console.info('-----businessKey------'+this.$route.params.businessKey, this.defaultConfig)
          this.setForm();
        });
      } else {
        this.defaultConfig = this.config;
        this.formKey = this.defaultConfig.formKey;
        this.formId = this.defaultConfig.formId;
        this.formInfoId = this.defaultConfig.id;
        // console.log('-----2----this.disabled---------',this.disabled,this.readOnly,this.$route);
        this.setForm();
        // console.info(this.defaultConfig)
      }
    },
    onEditorChange ({ editor, html, text }) {
      // console.log(editor, html, text);
    },
    onEditorBlur () {
      // 失去焦点事件
    },
    onEditorFocus (editor) {
      // 获得焦点事件
      // editor.enable(false); // 在获取焦点的时候禁用
    },
    onEditorReady () {
      // element.html = '<h1 class="ql-align-center">asdfasd</h1>'
    },
    getAddressCascader (column) {
      let area = {
        lazy: true,
        lazyLoad (node, resolve) {
          setTimeout(() => {
            let params = {
              rootId: node.root ? '1' : node.data.id,
              formColumn: column
            };
            getAddressOptions(params, this).then(data => {
              resolve(data);
            });
          }, 10);
        }
      };
      return area;
    },
    handleBeforeUpload (file) {
      this.readFile(file);
    },
    // 读取文件
    readFile (file) {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onloadstart = e => {
        this.uploadLoading = true;
        this.tableLoading = true;
        this.showProgress = true;
      };
      reader.onprogress = e => {
        this.progressPercent = Math.round(e.loaded / e.total * 100);
      };
      reader.onerror = e => {
        this.util.error('文件读取出错');
      };
      reader.onload = e => {
        this.util.success('文件读取成功');
        const data = e.target.result;
        this.excelData = excel.read(data, 'array');
        this.uploadLoading = false;
      };
    },
    handlerFieldClick (column) { // 用于千分号字段点击编辑
      this.mainData[column.columnName + 'isShow'] = true;
      this.$forceUpdate();
      // 设置字段focus
      this.$nextTick(function () {
        // console.log('----handlerFieldClick----',this.$refs,this.$refs['main-form-AMOUNT_'])
        this.$refs['main-form-' + column.columnName][0].focus();
      });
    },
    handlerFieldBlur (column) {
      this.mainData[column.columnName + 'isShow'] = false;
      this.$forceUpdate();
    },
    // 清空输入
    handleClear (column) {
      this.$set(this.mainData, column.columnName, '');
      this.$set(this.mainData, column.columnName + 'LABEL_', '');
      this.$forceUpdate();
    },
    // 点击导入按钮
    handlerExcelClick () {
      this.selectExcelVisible = true;
      this.excelList = this.config.formExcelList;
    },
    downloadExecl (edit) {
      this.excelModal = edit;
    },
    // 选择导入文件确认事件
    selectExcel () {
      let modal = {};
      if (this.excelModal) {
        modal = this.excelModal;
      } else {
        modal = this.excelList[0];
      }

      if (modal && modal.children && this.excelData) {
        for (let index = 0; index < this.subForms.length; index++) {
          let table = this.$refs['sub-form-' + this.subForms[index].key][0];
          let config = table.config;
          if (config.tableData === undefined) {
            config.tableData = [];
          }
          let data = [];
          let esxcelList = modal.children.filter(item => {
            return item.subTableName == config.tableName;
          });
          if (esxcelList && esxcelList[0]) {
            let excelData = this.excelData.find(item => {
              return item.sheetName == esxcelList[0].workSheetName;
            });
            if (excelData.results) {
              excelData.results.forEach(row => {
                let falg = true;
                let rowData = {};
                esxcelList.forEach(edit => {
                  rowData[edit.columnName] = row[edit.excelName];
                  // 如果字段唯一
                  if (edit.isOnly == 1 && this.config.tableData.find(item => {
                      return item[edit.columnName] === row[edit.excelName];
                    }) != undefined) {
                    // 如果有重复数据
                    falg = false;
                  }
                });
                if (falg) data.push(rowData);
              });
            }
          }
          // 删除最后一行空数据
          if (config.tableData.length > 0) {
            let row = config.tableData[config.tableData.length - 1];
            let flag = true;
            for (const key in row) {
              if (row[key]) {
                flag = false;
              }
            }
            if (flag) {
              config.tableData.splice(config.tableData.length - 1, 1);
            }
          }
          // console.log('-----selectExcel--2--',data)
          // 导入添加排序
          // 导入添加排序
          let sort = table.config.tableData.length;
          data.forEach(item => {
            item.SORT_ = sort++;
            table.columns.forEach(column => {
              item[column.columnName + 'isShow'] = false;
              if (item[column.columnName] === undefined) {
                item[column.columnName] = undefined;
              }
              if (column.widgetType && column.widgetType === 'select-form') {
                if (item[column.columnName + 'LABEL_'] === undefined) {
                  item[column.columnName + 'LABEL_'] = item[column.columnName];
                }
              }
              // 触发子表运算
              table.handlerChangeValue('', column, item, sort);
            });
            config.tableData.push(item);
          });
        }
      }
      this.selectExcelVisible = false;
    },
    setForm (refresh) {
      let _this = this;
      if (!refresh) {
        // console.log('--------setForm------',this);
        if(this.defaultConfig.parent && this.defaultConfig.parent.codeColumnNames){
          this.codeColumnNames = this.defaultConfig.parent.codeColumnNames;
        }
        this.tableName = this.defaultConfig['tableName'];
        this.entityId = this.defaultConfig['entityId'];
        let businessKey = this.defaultConfig.businessKey;
        this.businessKey = businessKey;
        // console.log(this.defaultConfig, 'defaultConfigdefaultConfig')
        // ifHasProcess为false
        if (this.defaultConfig['ifHasProcess'] === 1 || this.defaultConfig['enableProcess'] === 1) {
          this.processModel.ifHasProcess = true;
          this.processMonitorVisible = true;
          this.ifHasProcess = true;
        }
        // console.log(this.ifHasProcess+'--------------'+this.disabled)
        if (this.ifHasProcess && !this.disabled) {
          this.processModel.formKey = this.formKey;
          this.processModel.businessKey = this.businessKey;
          this.processFormVisible = true;
        }
      }

      let fileColumns = [];
      let formColumns = [];
      let formRows = [];
      let hiddenColumns = [];
      let subForms = [];
      let columns = this.defaultConfig.formColumns; // 表单字段
      let wfFormAuth = this.authsMap;// this.wfFormAuth // 获取流程过程节点权限
      let rules = {};
      let mainData = {};
      let userList = [];
      let ifCopy = this.ifCopy;
      if(this.validUtil.isNotNull(this.defaultConfig.jsCode)){
        let _vue = this;
        var ExtendFun = undefined;
        let str = "ExtendFun = function(){" +
          "this.vue = _vue;"+
          //"testAdd2 = undefined;"+
          this.defaultConfig.jsCode+
          "}; extendFun = new ExtendFun();";
        console.log('-----------',str);
        eval(str);
        console.log(extendFun,'-----',extendFun.vue,extendFun.testAdd,extendFun.testAdd2,extendFun.testAdd3,extendFun.testAdd3(1,2));
      }
      // console.log('-----ifCopy-----'+ifCopy)
      // 判断是否直接打开表单
      if (columns) {
        if (!refresh) {
          columns.forEach(column => {
            _this.formColumnTitleMap[column.title] = column.columnName;
            _this.formColumnsMap[column.columnName] = column;
          });
        }
        // 遍历每个表单中配置的查询列
        columns.forEach(column => {
          if (this.validUtil.isNotNull(column.tooltips)) {
            this.showTips = true;
          }

          // console.log(column.columnName+'--------',mainData[column.columnName],JSON.stringify(mainData))
          // 根据流程过程权限重新计算表单字段
          if (wfFormAuth && wfFormAuth[this.formInfoId] && wfFormAuth[this.formInfoId][column.columnName]) {
            let status = wfFormAuth[this.formInfoId][column.columnName];

            // 1,可编辑;2,只读;3,隐藏;4,必填'
            if (status === 1 && !ifCopy) {
              column.status = status;
              column.btnEdit = 1;
              column.btnLook = 1;
              column.hidden = 0;
              column.readOnly = 0;
            } else if (status === 2 && !ifCopy) {
              column.status = status;
              column.btnEdit = 0;
              column.btnLook = 1;
              column.hidden = 0;
              column.readOnly = 1;
            } else if (status === 3) {
              column.status = status;
              column.btnEdit = 0;
              column.btnLook = 0;
              column.hidden = 1;
              column.readOnly = 1;
            } else if (status === 3) {
              column.status = status;
              column.btnEdit = 1;
              column.btnLook = 1;
              column.hidden = 0;
              column.readOnly = 9;
            }
          }

          // console.info(column);
          // console.info("===="+column.col+'=='+column.title+'=='+this.defaultConfig.cloNum);
          column.newCol = column.col / this.defaultConfig.colNum;
          // 判断是否明细表
          if (column.widgetType !== 'sub-form') {
            mainData[column.columnName] = '';
            if (column.widgetType === 'select-form') {
              // console.info(column)
              mainData[column.columnName] = '';
              let selectFormKey = column.attr;
              try {
                if (selectFormKey.indexOf('{') > -1) {
                  let d = JSON.parse(selectFormKey);
                  column.selectFormKey = d.formKey;
                  if (d.queryParams) {
                    column.selectFormQueryParams = d.queryParams;
                  }
                  if (d.readOnly != undefined) {
                    column.selectFormReadOnly = d.readOnly;
                  } else {
                    column.selectFormReadOnly = true;
                  }
                  // 判断是否只读时，可以穿透别的表单
                  if (d.linked) {
                    if (this.validUtil.isNotNull(d.linked.formKey)) {
                      column.linkedVisible = true;
                      column.linked = d.linked;
                    }
                  }
                } else {
                  column.selectFormKey = selectFormKey;
                  column.selectFormReadOnly = true;
                }
              } catch (e) {
                console.log('---form-edit--setForm--parse attr----e---', selectFormKey, e);
                column.selectFormKey = selectFormKey;
              }
            } else if (column.widgetType === 'open-form') {
              // console.info(column)
              mainData[column.columnName] = '';
              let selectFormKey = column.attr;
              try {
                if (selectFormKey.indexOf('{') > -1) {
                  let d = JSON.parse(selectFormKey);
                  column.selectFormKey = d.formKey;
                  column.selectFormEditable = (d.editable == undefined) ? false : d.editable;

                  if (d.queryParams) {
                    column.selectFormQueryParams = d.queryParams;
                  }
                  if (d.readOnly != undefined) {
                    column.selectFormReadOnly = d.readOnly;
                  } else {
                    column.selectFormReadOnly = true;
                  }
                  // 判断是否只读时，可以穿透别的表单
                  if (d.linked) {
                    if (this.validUtil.isNotNull(d.linked.formKey)) {
                      column.linkedVisible = true;
                      column.linked = d.linked;
                    }
                  }
                } else {
                  column.selectFormKey = selectFormKey;
                  column.selectFormEditable = false;
                  column.selectFormReadOnly = true;
                }
              } catch (e) {
                console.log('---form-edit--setForm--parse attr----e---', selectFormKey, e);
                column.selectFormKey = selectFormKey;
                column.selectFormEditable = false;
              }
            } else if (column.widgetType === 'checkbox') {
              mainData[column.columnName + 'LABEL_'] = [];
            } else if (column.widgetType === 'explain') {

             //  console.log('------column-----',column,column.attr);

            } else if (column.widgetType === 'textarea') {
              let attr = column.attr;
              // 加载数据字典
              if (_this.validUtil.isNotNull(attr)) {
                let attrObj = JSON.parse(attr);
                //console.log("======1======"+attrObj.height,attrObj);
                column.height = attrObj.height ? ((attrObj.height + '').indexOf('px') > -1 ? attrObj.height : (attrObj.height + 'px')) : '100px';
                //console.log("======2======"+attrObj.height,attrObj);
              }
            }else if (column.widgetType === 'select-user-list') {
              let attr = column.attr;
              // 展示类型，默认是头像加名称
              column.showType = 1;
              // 加载数据字典
              if (_this.validUtil.isNotNull(attr)) {
                try {
                  let attrObj = JSON.parse(attr);
                  if(attrObj.showType){
                    column.showType = attrObj.showType;
                  }
                }catch (e) {
                  console.log('---form-edit--setForm--parse attr----e--select-user-list--', selectFormKey, e);
                }
              }
            }
          }

          // console.log('-----2-----',JSON.stringify(mainData))
          // console.info('------------'+column.columnName+'----------'+column.sourceType)
          // 判断是否有关联计算的
          if (column.sourceType) {
            if (column.sourceType === 'sub-form-summary') {
              _this.subFormSummary[column.columnName] = column.sourceAttr;
            } else if (column.sourceType === 'main-form-data') {
              _this.sourceData[column.columnName] = column.sourceAttr;
            } else if (column.sourceType === 'const') {
              mainData[column.columnName] = column.sourceAttr;
              if (column.javaType === 'Double' || column.javaType === 'Integer' || column.javaType === 'Float') {
                mainData[column.columnName] = Number(column.sourceAttr);
              }
              // 如果是switch组件需要特殊处理
              if (column.widgetType === 'switch') {
                mainData[column.columnName + '_SWITCH'] = (column.sourceAttr == '1' || column.sourceAttr == 'true');
              }
            } else if (column.sourceType === 'api') {
              // 触发接口
              this.initApiConfig(column);
            } else if (column.sourceType === 'rule-compute') {
              // 规则计算
              this.initRuleComputeConfig(columns, column);
            } else if (column.sourceType === 'cascade-form') { // 级联表单时，关联获取上层表单的值
              if (column.sourceAttr) {
                if (this.defaultConfig && this.defaultConfig.parentSelectedData && this.defaultConfig.parentSelectedData[column.sourceAttr] != undefined) {
                  mainData[column.columnName] = this.defaultConfig.parentSelectedData[column.sourceAttr];
                }
              }
            } else if (column.sourceType === 'file-data') {
              // 判断是否关联某个附件的附件名称
              let attr = column.sourceAttr;
              // console.log('---------file-name---------',attr)
              if (attr && attr.indexOf('.') > -1) {
                let array = attr.split('.');
                let srcColumnTitle = array[0];
                let srcColumnAttr = array[1];
                let srcColumnName = _this.formColumnTitleMap[srcColumnTitle];
                let srcColumn = _this.formColumnsMap[srcColumnName];
                // console.log('---------file-srcColumn---------',srcColumnName)
                if (srcColumnName && srcColumn) {
                  if (srcColumnAttr === '第1页截图') {
                    srcColumn.pdfToImage = true;
                    if (srcColumn.config) {
                      srcColumn.config.pdfToImage = true;
                    }
                  }
                  this.sourceFileData[srcColumnName] = {
                    desColumnName: column.columnName,
                    fieldCn: srcColumnAttr
                  };
                }
              }
              // console.log('---------this.sourceFileData-name---------',this.sourceFileData)
            } else {
              // 计算初始值
              this.computeInitValue(column, mainData);
            }
          }
          // console.log('-----3-----',JSON.stringify(mainData))
          //console.log(column.title+'------',column);
          // 处理隐藏条件信息
          if (this.validUtil.isNotNull(column.showCondition)) {
            this.initShowConditionConfig(column);
            //console.log(column.title+'----initShowConditionConfig----',this.showConditionData,column);
          }

          // 判断是否隐藏字段，如果隐藏字段统一放入最后一行
          if (false && column.hidden) {
            hiddenColumns.push(column);
          } else {
            // 判断是否数据字典
            if (column.attr && (column.widgetType === 'select' || column.widgetType === 'switch' || column.widgetType === 'radio' || column.widgetType === 'select-dic' || column.widgetType === 'checkbox')) {
              let attr = column.attr;
              if(column.widgetType === 'radio' ){
                mainData[column.columnName+'LABEL_'] = undefined;
              }
              column['options'] = [];
              if (attr.indexOf(',') > -1) {
                // 说明是直接写死类型
                let data = [];
                let options = attr.split(';');
                options.forEach(item => {
                  let option = item.split(',');
                  // 存入键值对
                  data.push({name: option[1], value: column.javaType === 'Integer' ? parseInt(option[0]) : option[0]});
                });
                //console.log("=========options========",options);
                column.options = data;
                // this.$forceUpdate()
              } else {
                // 标记字典正在请求后台
                _this.dicLoaded[column.columnName] = false;
                getDicData(attr).then(data => {
                  if (column.javaType === 'Integer') {
                    let newData = [];
                    data.forEach(item => {
                      newData.push({
                        value: parseInt(item.value),
                        name: item.name
                      });
                    });
                    column.options = newData;
                  } else {
                    column.options = data;
                  }
                  _this.dicLoaded[column.columnName] = true;
                  // console.info('----getDicData---'+column.title,column.options)
                  this.$forceUpdate();
                }).catch(() => {
                  _this.dicLoaded[column.columnName] = true;
                });
              }
            } else if (column.widgetType === 'select-sql') {
              let attr = column.attr;
              // 加载数据字典
              if (_this.validUtil.isNotNull(attr)) {
                // 标记字典正在请求后台
                _this.dicLoaded[column.columnName] = false;
                getSqlDicData({formKey: this.formKey, columnId: column.id}).then(data => {
                  if (column.javaType === 'Integer') {
                    let newData = [];
                    data.forEach(item => {
                      newData.push({
                        value: parseInt(item.value),
                        name: item.name
                      });
                    });
                    column.options = newData;
                  } else {
                    column.options = data;
                  }
                  _this.dicLoaded[column.columnName] = true;
                  // console.info('----getDicData---'+column.title,column.options)
                  this.$forceUpdate();
                }).catch(() => {
                  _this.dicLoaded[column.columnName] = true;
                });
              }
            } else if (column.widgetType === 'full-editor') {
              let config = { id: this.businessKey, readOnly: this.formColumnReadOnly(column)};
              this.fullEditorImageUpload = Object.assign(this.fullEditorImageUpload,config);
            } else if (column.widgetType === 'pic-view') {
              let attr = column.attr;
              // 加载数据字典
              if (_this.validUtil.isNotNull(attr)) {
                let attrObj = JSON.parse(attr);
                column.width = attrObj.width ? ((attrObj.width + '').indexOf('px') > -1 ? attrObj.width : (attrObj.width + 'px')) : '100px';
                column.height = attrObj.height ? ((attrObj.height + '').indexOf('px') > -1 ? attrObj.height : (attrObj.height + 'px')) : '100px';
                column.ifThumb = column.ifThumb ? column.ifThumb : true;
              }
            } else if (column.widgetType === 'file') {
              let attr = column.attr;
              let config = {xtype: column.columnName, id: this.businessKey, readOnly: this.formColumnReadOnly(column)};
              // 加载数据字典
              if (_this.validUtil.isNotNull(attr)) {
                let attrObj = JSON.parse(attr);
                config = {...config, ...attrObj};
              }
              // 判断是否有关联附件，并且是pdf附件截取第一个截图
              if (column.pdfToImage) {
                config.pdfToImage = true;
              }
              // console.log('-------------'+attr,config);
              column.config = config;
              fileColumns.push(column);
            }
            if (column.widgetType === 'sub-form') { // 默认有多个明细表时，所有明细表的位置参照第一个明细表位置
              // if (formRows.length < column.row) {
              // 判断是否已阅点赞
              let javaType = column.javaType;
              if(javaType && javaType === 'ReadLike'){
                this.readLikeVisible = true;
                this.readLikeFormInfoId = column.id;
              }else{
                this.showReadLike = false;
                if (formRows[column.row - 1] === undefined) {
                  formRows[column.row - 1] = [];
                  let subFormsColumn = {
                    widgetType: 'sub-form',
                    row: column.row,
                    col: column.col,
                    subForms: []
                  };
                  column.index = subForms.length + 1;
                  subFormsColumn.subForms.push(column);
                  formRows[column.row - 1].push(subFormsColumn);
                } else {
                  // 说明是两个明细表在同一行
                  let subFormsColumn = formRows[column.row - 1][0];
                  // console.info(subFormsColumn)
                  // console.info(subFormsColumn.subForms)
                  column.index = subForms.length + 1;
                  subFormsColumn.subForms.push(column);
                }
                if (column.config) {
                  column.config.formKey = this.formKey;
                  column.config.parent = _this;
                  column.config.title = column.title;
                  column.config.tableData = [];
                  if (this.wfFormAuth && this.wfFormAuth[column.id]) {
                    column.config.wfFormAuth = this.wfFormAuth[column.id];
                  }
                  column.config.ifCopy = this.ifCopy;
                  // 判断是否有注册api是主表字段切换修改明细表，初始化事件并且注册
                  this.registerSubFormChangeEvent(column);
                }
                column.key = column.columnName;
                subForms.push(column);
              }

            } else {
              //console.log(column.title+'======',column.row,column.col,formRows)
              // if (formRows.length < column.row) {
              if (formRows[column.row - 1] === undefined) {
                formRows[column.row - 1] = [];
              }
              formRows[column.row - 1].push(column);
              formColumns.push(column);
            }
          }
          // console.log('----------',JSON.stringify(mainData))
          if (column.require) {
            let rule = {field: column.columnName,
              validType: column.validType,
              column: column,
              validator: _this.validateField,
              required: true,
              message: '请输入' + column.title,
              trigger: 'blur'};
            if (column.javaType === 'Double' || column.javaType === 'Integer' || column.javaType === 'Float') {
              // if (column.widgetType !== 'select') {
              rule.type = 'number';
              // }
            }
            rules[column.columnName] = [rule];
          }
          if (column.validType) {
            if (!rules[column.columnName]) {
              rules[column.columnName] = [];
            }
            rules[column.columnName].push({
              field: column.columnName,
              column: column,
              validType: column.validType,
              validator: _this.validateField,
              message: '格式错误',
              trigger: 'blur'
            });
          }
          if (column.validRule) {
            if (!rules[column.columnName]) {
              rules[column.columnName] = [];
            }
            rules[column.columnName].push({
              field: column.columnName,
              column: column,
              validator: _this.validateField,
              message: column.validMessage,
              trigger: 'blur'
            });
          }
        });
        if (!refresh) {
          let sessionProj = this.sessionUtil.getProjInfo(this);
          if (sessionProj) {
            mainData = Object.assign(mainData, sessionProj);
            for (let key in sessionProj) {
              let column = this.formColumnsMap[key];
              // 触发change事件
              if (column && mainData[key] !== undefined) {
                this._handlerValueChange(column, mainData[key]);
              }
            }
          }
          /* if(!mainData.SORT_ && this.defaultConfig.parent) {
            if (this.defaultConfig.type === 1 && this.defaultConfig.parent.gridData){
              mainData.SORT_ = this.defaultConfig.parent.gridData.length+1
            }
            if (this.defaultConfig.type === 2 && this.defaultConfig.parent.selectedData[0] && this.defaultConfig.parent.selectedData[0]._parent && this.defaultConfig.parent.selectedData[0]._parent.children){
              mainData.SORT_ = this.defaultConfig.parent.selectedData[0]._parent.children.length+1
            }
          } */
          // console.log('-----------',mainData)
          // 判断是否是编辑 如果不是编辑 则添加initValues
          if (this.defaultConfig && this.defaultConfig.initValues && !this.defaultConfig.businessKey) {
            let initValues = this.defaultConfig.initValues;
            // console.log('------setForm----initValues----',initValues)
            for (let key in initValues) {
              // console.info(this.mainData[key])
              // console.info(initValues[key]+'-----'+key+'----'+mainData[key])
              if (this.validUtil.isNull(mainData[key])) {
                // console.info('---------')
                mainData[key] = initValues[key] + '';
                // 由于控件可能是弹框列表 给_lable也赋值 避免无法显示
                mainData[key + 'LABEL_'] = initValues[key + 'LABEL_'] ? initValues[key + 'LABEL_'] + '' : initValues[key] + '';
              }
            }
          }
        }
        // if (!this.defaultConfig.businessKey && this.cookieUtil.get(this.$route.path)) {
        //   mainData = Object.assign(mainData, JSON.parse(this.cookieUtil.get(this.$route.path)))
        // }
        // console.log('-------setForm------',this.defaultConfig.initValues,mainData)
        // rules['test'] = [{field: 'test', required: true, message: '请输入1111', trigger: 'change'}]
        // console.log('--------',this.readOnly);
        // console.log('-----initRule----',rules)
        _this.rules = rules;
        // console.log('--1--formRows--1--' , formRows)
        _this.formRows = formRows;
        _this.hiddenColumns = hiddenColumns;

        if (!refresh) {
          _this.fileColumns = fileColumns;
          _this.formColumns = formColumns;
          _this.mainData = mainData;
          _this.subForms = subForms;
          _this.userList = userList;
          // console.log('----1---',this.readOnly);
          _this.$nextTick(function () {
            // console.log('----3----',_this.readOnly);
            // 因为数据字典可能没有加载完成，所以需要延迟执行loadData
            _this.loadCount = 0;
            _this._loadData();
            // this.loading = false
          });
          // console.log('------setForm--------',this.mainData,this.formColumns)
        }
        // console.info(subForms);
        // console.info(hiddenColumns);
      }

      // console.info(this.$refs)
    },
    _loadData () { // 因为数据字典可能没有加载完成，所以需要延迟执行loadData
      var _this = this;
      // console.log('-----_loadData-----'+_this.loadCount)
      //console.log('---_loadData----',this.readOnly)
      var loaded = true;
      if (_this.dicLoaded) {
        for (let key in _this.dicLoaded) {
          if (_this.dicLoaded[key] === false) {
            loaded = false;
            break;
          }
        }
      }
      if (loaded || _this.loadCount > 50) {
        _this.loadData();
      } else {
        _this.loadCount++;
        setTimeout(_this._loadData, 20);
      }
    },
    subFormRef () {
      // this.subFormCount =  this.subFormCount+1;
      // let ref = 'sub-form-'+this.subFormCount;
      // console.info('------ref------'+ref)
      // return ref;
    },
    // 流程修改字段权限
    updateWfFormAuth (wfFormAuth) {
      let _this = this;
      if (wfFormAuth) {
        this.authsMap = wfFormAuth;
        if (this.authsMap && this.authsMap[this.formInfoId]) {
          for (let columnName in this.authsMap[this.formInfoId]) {
            let status = this.authsMap[this.formInfoId][columnName];
            let column = this.formColumnsMap[columnName];
            if (status === 4) {
              // 避免重复设置
              let find = this.rules[columnName];
              if (!find) {
                column.require = true;
                if (column.require) {
                  let rule = {field: column.columnName,
                    validType: column.validType,
                    column: column,
                    validator: _this.validateField,
                    required: true,
                    message: '请输入' + column.title,
                    trigger: 'blur'};
                  if (column.javaType === 'Double' || column.javaType === 'Integer' || column.javaType === 'Float') {
                    // if (column.widgetType !== 'select') {
                    rule.type = 'number';
                    // }
                  }
                  this.rules[column.columnName] = [rule];
                }
                // console.log('------this.rules-----',this.rules)
              }
            }
            // this.formRows = []
          }
          this.$forceUpdate();
          // this.setForm (true)
        }
      } else {
        this.authsMap = {};
      }
    },
    updateReadOnly (readOnly) { // 方便流程修改表单状态
      this.readOnly = readOnly;
      if (readOnly === false) {
        this.disabled = false;
      }
      // 判断是否又传人readOnly 权限等级最高
      if (this.openConfig && this.openConfig.readOnly != undefined) {
        this.readOnly = this.openConfig.readOnly;
        // console.info('-----this.readOnly -------'+this.readOnly )
      }
      // console.log('------updateReadOnly-------',this.readOnly)
    },
    setCache (data) {
      this.cookieUtil.set('bus-form-' + this.defaultConfig.tableName, data);
    },
    getCache () {
      let data = this.cookieUtil.get('bus-form-' + this.defaultConfig.tableName);
      return data;
    },
    getRenderApi () {
      // console.info(this.config)
      // console.info(this.defaultConfig.events)
      if (this.defaultConfig.events) {
        let events = this.defaultConfig.events.find(event => {
          // console.info(event)
          return parseInt(event.type) === EVENT_TYPE.NEW_REDNER;
        });
        return events;
      }
      return null;
    },
    openAddress (column) {
      // 添加地图组件禁止选择
      if (!this.formColumnReadOnly(column)) {
        this.clickCloumn = column;
        this.addressObj.addressVisible = true;
        if (this.clickCloumn.attr) {
          let attr = JSON.parse(this.clickCloumn.attr);
          if (attr && attr['rule']) {
            if (!this.addressObj.point || typeof this.addressObj.point === 'string') {
              this.addressObj.point = [];
            }
            for (let columnName in attr['rule']) {
              let key = attr['rule'][columnName];
              if (key === 'address') {
                this.addressObj.address = this.mainData[columnName];
              } else if (key === 'lng') {
                this.addressObj.point[0] = this.mainData[columnName];
              } else if (key === 'lat') {
                this.addressObj.point[1] = this.mainData[columnName];
              } else if (key === 'province') {
                this.addressObj.province = this.mainData[columnName];
              } else if (key === 'city') {
                this.addressObj.city = this.mainData[columnName];
              } else if (key === 'county') {
                this.addressObj.county = this.mainData[columnName];
              } else if (key === 'addressLocation') {
                this.addressObj.location = this.mainData[columnName];
              }
            }
          }
          if (typeof this.addressObj.point !== 'string' && this.addressObj.point[0] && this.addressObj.point[1]) {
            this.addressObj.location = this.addressObj.point.join(',');
          }
        }
      }
    },
    // 选择项目地址回调
    chooseAddress (data) {
      this.mainData[this.clickCloumn.columnName] = data.address;
      if (this.clickCloumn.attr) {
        let attr = JSON.parse(this.clickCloumn.attr);
        if (attr && attr['rule']) {
          let point = data.addressLocation.split(',');
          for (let columnName in attr['rule']) {
            let key = attr['rule'][columnName];
            if (key === 'address') {
              this.mainData[columnName] = data.address;
            } else if (key === 'lng') {
              this.mainData[columnName] = point[0];
            } else if (key === 'lat') {
              this.mainData[columnName] = point[1];
            } else if (key === 'province') {
              this.mainData[columnName] = data.province;
            } else if (key === 'city') {
              this.mainData[columnName] = data.city;
            } else if (key === 'county') {
              this.mainData[columnName] = data.county;
            } else if (key === 'addressLocation') {
              this.mainData[columnName] = data.addressLocation;
            }
          }
        }
      }
      /* this.mainData[this.clickCloumn.columnName] = data.address
      this.mainData[this.clickCloumn.columnName + 'LOCATION_'] =
      this.mainData[this.clickCloumn.columnName + 'PROVINCE_'] = data.province
      this.mainData[this.clickCloumn.columnName + 'CITY_'] = data.city
      this.mainData[this.clickCloumn.columnName + 'COUNTY_'] = data.county */
    },
    getParams () {
      let _this = this;
      let businessKey = this.businessKey;
      // console.info(this.defaultConfig)

      // 判断是否搜索,然后拼接搜索
      let params = {
        'formKey': _this.defaultConfig.formKey,
        'id': _this.defaultConfig.id, // 表单formId
        'businessKey': businessKey,
        'tableName': _this.defaultConfig.tableName
      };

      // 如果时编辑，则默认首次渲染是true
      if (this.validUtil.isNotNull(businessKey)) {
        this.ifFormEditRender = true;
      }

      // let event = this.`getRenderApi`()
      // if (event && event != null) {
      //   params.apiId = event.apiId
      // 修改所有接口调用在后台执行
      params.params = this.mainData;
      let sessionProj = null;
      if (window.localStorage.getItem('_session_proj' + this.sessionUtil.getUser().id)) {
        sessionProj = JSON.parse(window.localStorage.getItem('_session_proj' + this.sessionUtil.getUser().id));
      } else if (this.getFormConfig['_session_proj' + this.sessionUtil.getUser().id]) {
        sessionProj = this.getFormConfig['_session_proj' + this.sessionUtil.getUser().id].data;
        // console.log('------mainData-------', mainData, sessionProj)
      }
      // console.log('------mainData-------', mainData, sessionProj)
      if (sessionProj) {
        params.params['session-proj-uid'] = sessionProj['PROJ_ID_'] || sessionProj['PROJ_UID_'];
      }
      return params;
    },
    getOpenApi () { // 表单编辑打开执行事件
      // console.info(this.config)
      // console.log('------getEditRenderApi-------', this.config.events)
      if (this.defaultConfig.events) {
        let events = this.defaultConfig.events.filter(event => {
          // console.info(EVENT_TYPE.EDIT_OPEN+'-------------'+event.type,event)
          return parseInt(event.type) === EVENT_TYPE.EDIT_OPEN;
        });
        return events;
      }
      return null;
    },
    loadData () {
      // console.log('------loadData-----',this.mainData)
      /* return; */
      let _this = this;

      // }
      // 获取表单数据
      getMainData(this.getParams()).then(data => {
        let mainData = data;
        // console.log((data['CONTENT_'].indexOf('&nbsp;')>-1)+'-----html---1--'+(data['CONTENT_'].indexOf(' ')>-1)+'-1--'+JSON.stringify(data['CONTENT_']))
        // console.log('-------',mainData,this.readOnly);
        if (mainData) {
          this.mainData = Object.assign(this.mainData, mainData);
          this.defaultConfig.formColumns.forEach(column => {
            let key = column.columnName;
            if (column.widgetType && column.widgetType === 'switch') {
              this.mainData[key + '_SWITCH'] = this.mainData[key + '_SWITCH'] === 'true';
            } else if (column.widgetType && column.widgetType === 'select-date-time') {
              this.mainData[key] = this.mainData[key + 'LABEL_'] || this.mainData[key];
            } else if (column.widgetType && column.widgetType === 'full-editor') {
              //var c = document.createElement('div');
              //c.innerHTML = this.mainData[key];
              //let html = c.innerHTML;
              //console.log('-----html---1---',html);
              // 替换图片根地址
              //let baseUrl = this.util.getBaseUrl();
              //html = html.replaceAll('src="share/temp','src="'+baseUrl+'/share/temp');
              //html = html.replaceAll('src="share/','src="'+baseUrl+'/share/');
              //console.log('-----html---2---',html);
              //this.mainData[key] = html;
              // this.mainData[key] = html;
              // console.log(key+'------------'+this.mainData[key]);
              this.setEditorData(column,this.mainData[key]);
            } else if (column.widgetType === 'radio' || column.widgetType === 'select' || column.widgetType === 'select-sql' || column.widgetType === 'select-dic') {
              // 解决值为number类型显示不正确bug
              // this.mainData[key] = column.widgetType === 'select' ? this.mainData[key] + '' : this.mainData[key]
              // this.mainData[key] =  this.mainData[key]
              // 如果是多选
              this.mainData[key + 'LABEL_'] = this.mainData[key];
              if (column.multiple === 1) {
                let options = this.mainData[key].split(',');
                if (options && options.length > 0) {
                  this.mainData[key + 'LABEL_'] = options;
                } else {
                  this.mainData[key] = [];
                }
              }
              // this.$forceUpdate();
            } else if (column.widgetType === 'select-user-list' || column.widgetType === 'select-project-member' || column.widgetType === 'select-role-list' || column.widgetType === 'select-depart-list' || column.widgetType === 'select-cascade') {
              let tempdata = this.mainData[key]||[];
              let data = tempdata.sort(this.compare("value"))
              if (column.widgetType === 'select-cascade' && data && data.length > 0) {
                let edit = '';
                data.forEach(v => {
                  if (edit !== '') {
                    edit += '/';
                  }
                  edit += v.label;
                });
                this.mainData[column.columnName + 'cascade'] = data.map((item)=>parseInt(item.value));
                this.mainData[column.columnName + 'placeholder'] = edit;
              }else {
                this.mainData[column.columnName] = data;
                this.userList[column.columnName] = data;
              }
            }else if(column.widgetType === 'cascader'){//级联选择
              let data = this.mainData[key];
              if(data){
                this.mainData[column.columnName + 'cascade'] = data.split(",");
              }
              

            } else if (column.widgetType === 'checkbox') {
              this.mainData[key + 'LABEL_'] = this.mainData[key];
              let options = this.mainData[key].split(',');
              if (options && options.length > 0) {
                this.mainData[key + 'LABEL_'] = options;
              } else {
                this.mainData[key + 'LABEL_'] = [];
              }
            } else if (column.widgetType === 'select-user-multi') {
              // 判断是否以id开头
              if (column.columnName.indexOf('UID_') > -1) {
                let columnNameCn = column.columnName.substring(0, column.columnName.indexOf('UID_')) + 'NAME_';
                this.mainData[key + 'LABEL_'] = this.mainData[columnNameCn] || '';
              }
            }
          });
          // console.log(mainData['CREATE_USER_'],'----------',this.sessionUtil.getUserUid(),mainData['CREATE_USER_'] !== this.sessionUtil.getUserUid())
          if (mainData['CREATE_USER_'] && mainData['CREATE_USER_'] !== this.sessionUtil.getUserUid() && !this.sessionUtil.isAdmin() && !this.sessionUtil.isCompanyAdmin()) {
            // 解决我参与的任务 状态无法修改问题 注释掉this.disabled = true
            // this.disabled = true
            // 判断表单的修改权限
            let editAuth = this.config.editAuth;
            // console.log(editAuth+'----editAuth-----',mainData['SUB_COMPANY_'],this.sessionUtil.getSubCompanyUid());
            // 仅有修改按钮权限且同组织的人可修改
            if(editAuth === 1){
              // 判断是否相同组织
              if(mainData['SUB_COMPANY_'] !== this.sessionUtil.getSubCompanyUid()){
                this.readOnly = true;
              }
            }else if(editAuth === 2){
              // 仅有修改按钮权限的人可修改

            }else{

              this.readOnly = true;
            }
          }
          /* if (mainData['CREATE_USER_'] && mainData['CREATE_USER_'] === this.sessionUtil.getUserUid() ) {
            // 判断是否发起人
            if (this.ifHasProcess) {
              this.processModel.formKey = this.formKey
              this.processModel.businessKey = this.businessKey
              this.processFormVisible = true
            }
          } */
          // 如果流程状态不是空，则说明是送审或者已审，则需要只读
          if (this.validUtil.isNotNull(mainData['PROC_STATUS_']) && mainData['PROC_STATUS_'] != 0 && mainData['PROC_STATUS_'] != '0') {
            this.readOnly = true;
            if ((mainData['PROC_STATUS_'] === -5 || mainData['PROC_STATUS_'] === '-5')) {
              if(this.sessionUtil.isCompanyAdmin()){
                this.rollbackDataBtnVisible = true;
              }
              // 判断是否允许转阅
              if(this.sessionUtil.isAllowWfFinishedCopy()){
                this.transferCopy  = true
              }
            }
          }
          // console.log(this.config.parentColumn+'-----------------'+this.mainData[this.config.parentColumn])
          if (this.config.parentColumn && this.validUtil.isNull(this.mainData[this.config.parentColumn])) {
            this.mainData[this.config.parentColumn] = this.config.rootId;
            this.mainData[this.config.parentColumn + 'LABEL_'] = this.config.rootText;
          }
        }
        // console.log('-----html---1---', this.mainData['CONTENT_']);
        // debugger
        // console.log('-------------loadData-------触发------',this.mainData['SUBJECT_'],this.mainData['TYPE_'])

        // 初始化计算规则计算数据来源
        _this.computeRuleComputeConfig();

        // 初始化计算隐藏显示
        _this.computeShowConditionConfig();

        // 加载明细表数据
        _this.$nextTick(function () {
          // 加载流程
          _this.initProcess();
          let activeTab = undefined;
          for (let index = 0; index < _this.subForms.length; index++) {
            let ref = _this.$refs['sub-form-' + _this.subForms[index].key];
            if(ref && ref[0]){
              if(!activeTab){
                activeTab = 'subForm'+(index+1);
                _this.activeTab = activeTab;
              }
              ref[0].loadData(_this.defaultConfig.businessKey);
              // return
            }

          }
        });
        // console.log('-----------------his.openConfig.readOnly---------------',this.readOnly,this.openConfig.readOnly,this.openConfig)
        // 最后通过传入参数处理readonly 权限等级最高
        if (this.openConfig && this.openConfig.readOnly != undefined) {
          this.readOnly = this.openConfig.readOnly;
          // console.info('-----this.readOnly -------'+this.readOnly )
        }
        this.loading = false;
      });

      // 判断是否有表单编辑打开时执行事件
      let events = this.getOpenApi();
      // console.log('--------events--------',events)
      if (events) {
        events.forEach(event => {
          // console.log('--------event--------'+API_RUN_TYPE.isInterface(event.apiConfig['runtype']),event)
         if (event.apiConfig && API_RUN_TYPE.isInterface(event.apiConfig['runtype'])) {
            let urlAttr = event.apiConfig['runsql'];
            if (urlAttr) {
              if (urlAttr.indexOf(',') > -1) {
                let urlArr = urlAttr.split(',');
                let url = urlArr[0];
                let method = urlArr[1];
                url = this.util.replaceStr(url, {'ID_': this.businessKey});
                this.util.request(method, url);
              }
            }
          }
        });
      }
    },
    handlerUpdateFormEditRenderStatus () { // 用户行为明细表字段编辑change时触发革更新
      // console.log('--------------handlerUpdateFormEditRenderStatus---------------')
      this.ifFormEditRender = false;
    },
    openSelectForm (column) { // 打开树表选择框
      // console.info('------openSelectForm------1--')
      if (this.formColumnReadOnly(column)) {
        return;
      }
      let mainData = this.getData();
      if (mainData && mainData.mainFormDataMap) {
        mainData = mainData.mainFormDataMap;
        // 避免数据出问题，需要移除字段本身的值
        if (this.validUtil.isNotNull(mainData[column.columnName])) {
          delete mainData[column.columnName];
        }
        // console.log(column.columnName+'----------openSelectForm----------',column,mainData[column.columnName])
        // 判断是否指定了弹框传参queryParams
        if (column.selectFormQueryParams) {
          let data = {};
          column.selectFormQueryParams.forEach(item => {
            let k = item.key;
            let v = item.value;
            if (this.validUtil.isNotNull(v) && v.indexOf('{') > -1) {
              let key = v.trim().substring(1, v.lastIndexOf('}'));
              v = mainData[key];
            }
            data[k] = v;
          });
          mainData = data;
        }
        this.selectFormQueryParams = mainData;
      }
      // 兼容open-form中attr是json的情况
      this.selectFormKey = column.selectFormKey || column.attr;
      this.selectFormReadOnly = column.selectFormReadOnly;
      this.formSelectBindColumn = column;
      this.selectFormVisible = true;
    },
    setFormWidth (formConfig) {
      this.selectFormConfig = formConfig;
    },
    checkSelfSelectValid () {
      this.$refs['mainForm'].validate((valid) => {

      });
    },
    confirmSelect (row) { // 弹框选择确定数据
      let c = this.formSelectBindColumn;
      let selectedData = [];
      let selectForm = this.$refs['select-form'];
      if (selectForm && selectForm.getSelectedData) {
        selectedData = selectForm.getSelectedData();
      }
      // console.info('-----------selectedData----------',selectedData)
      if (selectedData.length === 0 && row.length === 0) {
        this.util.warn('请选择数据');
        return;
      }
      // 表示单选
      if (selectedData.length === 1 || row.length === 1) {
        let selectedRow = row ? row[0] : selectedData[0];
        if (this.formSelectBindColumn != null) {
          // 如果是选择上级目录
          if (this.formSelectBindColumn.widgetType === 'select-self') {
            this.mainData['PARENT_ID_'] = selectedRow['ID_'];
            this.mainData['PARENT_NAME_'] = selectedRow['NAME_'];
            let column = this.formColumnsMap['PARENT_ID_'];
            // 触发change事件
            if (column) {
              this._handlerValueChange(column, this.mainData['PARENT_ID_']);
            }
            column = this.formColumnsMap['PARENT_NAME_'];
            // 触发change事件
            if (column) {
              this._handlerValueChange(column, this.mainData['PARENT_NAME_']);
            }
          } else if (this.formSelectBindColumn.widgetType === 'select-form' || this.formSelectBindColumn.widgetType === 'open-form') {
            // console.info(selectedRow)
            // 保存到state中用来其他表单初始化时使用
            this.setFormSelectData({formKey: this.formSelectBindColumn.attr, data: selectedRow});
            // 循环遍历根据数据回填规则
            for (let key in selectedRow) {
              // console.log('-------key----',key,selectedRow)
              this.mainData[key] = selectedRow[key];
              this.$refs['mainForm'].validateField(key);
              this.$forceUpdate();
            }
            // console.log('---------aaa----------',selectedRow)
            // 先赋值之后再触发change，
            for (let key in selectedRow) {
              let column = this.formColumnsMap[key];
              // console.log('---------aaa----2------'+key,column)
              if (column) {
                // console.log('---------aaa----3------'+key,column,this.apiSourceData[column.columnName])
                // 触发change事件，解决LABEL_还未赋值就触发change，导致字段为规则计算的延迟
                this._handlerValueChange(column, selectedRow[key]);
              }
              this.$forceUpdate();
            }
            // 如果是控件类型是select-form，并且attr_ = project-info,并且所属模块是在切换项目的模块，则修改全局项目信息
            if (c.attr && c.selectFormKey === 'project-info') {
              // console.log('-------confirmSelect--------',c)
              // 调用app.vue页面中全局bus监听切换顶部的项目
              this.$bus.$emit('bus-session-project-change', selectedData);
            }
          }
        }
      }

      // console.info(selectedData);
      this.selectFormVisible = false;
      this.formSelectBindColumn = null;
    },
    handlerValueChange (column, value) { // 主表数据change时触发，用户行为事件
      // console.info(column.columnName + '------handlerValueChange------' + value+'----ifFormEditRender----'+this.ifFormEditRender)
      // 如果是用户行为事件，则修改状态
      this.ifFormEditRender = false;
      this._handlerValueChange(column, value);
    },
    _handlerValueChange (column, value) { // 内部触发，比如 规则计算，明细表向上合计触发
      // console.info(column.columnName + '------_handlerValueChange------' + value+'----ifFormEditRender----'+this.ifFormEditRender)
      // debugger
      let _this = this;

      // 判断如果是switch组件需要特殊处理
      if (column.widgetType === 'radio') {
        this.mainData[column.columnName] = value;
        this.$forceUpdate();
      }

      // 先判断数据来源绑定主表字段的情况
      if (this.sourceData) {
        for (let key in this.sourceData) {
          let sourceColumnName = this.sourceData[key];
          // console.log('----sourceColumnName-----',sourceColumnName)
          // 判断是否当前列的数据触发影响其他列
          if (sourceColumnName === column.columnName) {
            let destColumn = this.formColumnsMap[key];
            // 判断是否中文字段
            if (destColumn.widgetType === 'number-cn' && value != undefined) {
              let newValue = this.util.numToCn(value);
              this.mainData[key] = newValue;
            }
          }
        }
      }
      // 判断是否会触发api
      let apiConfigData = this.apiSourceData[column.columnName];
      // console.log(column.columnName+'----handlerValueChange-----',apiConfigData)
      if (apiConfigData) {
        // console.info(apiConfigData)
        // 可能配置多个
        apiConfigData.forEach(apiConfig => {
          let mainData = this.getData().mainFormDataMap;
          let params = {};
          if (mainData) {
            if (apiConfig.children) {
              apiConfig.children.forEach(item => {
                // 判断是否需要表单传参
                if (item.value && item.value.indexOf('{') > -1) {
                  let value = item.value.trim();
                  let columnName = value.substring(value.indexOf('{') + 1, value.indexOf('}'));
                  // 获取字段参数值
                  let val = mainData[columnName];
                  params[item.code || columnName] = val === undefined ? '' : val;
                }
              });
            }
            // 获取sql中需要传入后台的参数
            if (apiConfig.runsql) {
              let runsql = apiConfig.runsql;
              for (let field in mainData) {
                let key = null;
                if (runsql.indexOf('{' + field + '}') > -1) {
                  key = field;
                }
                if (key && mainData[key]) {
                  params[key] = mainData[key];
                }
              }
            }
          }
          params[column.columnName] = value;
          // 判断是否是接口
          if (apiConfig.runtype === 'Interface') {
            params._url = apiConfig.runsql;
          }
          // console.info(apiConfig)
          if (apiConfig.eventType && apiConfig.eventType === EVENT_TYPE.SUB_FORM_CHANGE_BY_MAIN_FORM) {
            // 调用主表字段切换修改明细表,刷新明细表
            let subForms =_this.getSubForm(apiConfig.subFormKey);
            if(subForms){
              subForms.loadDataByEvent({
                apiConfig, apiId: apiConfig.id, resetId: true
              }, _this.defaultConfig.businessKey);
            }
          } else {
            // 调用获取主表数据
            getDataByApi(apiConfig.id, params).then(res => {
              if (res) {
                let data = Array.isArray(res) ? res[0] : res;
                for (let key in data) {
                  // console.info(key+'------'+data[key])
                  let desColumn = _this.formColumnsMap[key];
                  // 如果不是编辑时第一次渲染，或者编辑时第一次渲染，但是时静默类型，则就每次都计算
                  if (!this.ifFormEditRender || (this.ifFormEditRender && desColumn && desColumn.silence && desColumn === 1)) {
                    // 遍历更新数据
                    _this.mainData[key] = data[key];
                    // 触发接口调用
                    // console.info(key+'----------'+desColumn)
                    if (desColumn) {
                      // 触发change事件
                      this._handlerValueChange(desColumn, data[key]);
                    }
                  }
                }
              }
            });
          }
        });
      }
      // 判断如果是switch组件需要特殊处理
      if (column.widgetType === 'switch') {
        this.mainData[column.columnName] = value ? 1 : 0;
        this.mainData[column.columnName + '_SWITCH'] = value;
        this.$forceUpdate();
      }
      // 如果是select 需给本身赋值
      if (column.widgetType === 'select' || column.widgetType === 'select-dic' || column.widgetType === 'select-sql') {
        this.mainData[column.columnName] = value;
      }
      // 如果是多选框
      if (column.widgetType === 'checkbox') {
        if(!Array.isArray(value)){
          this.mainData[column.columnName] = value;
          let options = this.mainData[column.columnName].split(',');
          if (options && options.length > 0) {
            this.mainData[column.columnName + 'LABEL_'] = options;
          } else {
            this.mainData[column.columnName + 'LABEL_'] = [];
          }
        } else {
          let tempvalue = value.toString();
          this.mainData[column.columnName] = tempvalue;
        }
      }
      // console.log('-------------handlerValueChange-------触发------',this.mainData['SUBJECT_'],this.mainData['TYPE_'],this.mainData['START_DATE_'])
      // 如果是下拉框
      if (column.widgetType === 'select' || column.widgetType === 'select-sql' || column.widgetType === 'select-dic') {
        // 如果是UID_ 或者ID结尾
        if (column.columnName && column.columnName.lastIndexOf('UID_') > -1) {
          let name = column.columnName.split('UID_');
          this.mainData[name[0] + 'NAME_'] = this.dicValue(column, value);
        }
        if (column.columnName && column.columnName.lastIndexOf('ID_') > -1) {
          let name = column.columnName.split('ID_');
          this.mainData[name[0] + 'NAME_'] = this.dicValue(column, value);
        }
        let valueObj = {
          name: this.dicValue(column, value),
          value: value
        };
        if (column.attr && column.attr.indexOf('backFillRule') > -1) {
          let attrObj = JSON.parse(column.attr);
          let backFillRule = attrObj.backFillRule;
          for (let key in backFillRule) {
            this.mainData[key] = valueObj[backFillRule[key]];
          }
        }
      }
      // 计算规则计算的
      this.computeRuleComputeConfig(column.columnName);
      // 计算显示隐藏规则
      this.computeShowConditionConfig(column);

      // 由于有显影计算，所以需要等计算完之后再执行
      this.$nextTick(()=>{
        let activeTab = undefined;
        let isOld = false;
        // 触发明细表中如果表达式中配置主表字段进行计算，比如合同中付款明细付款基恩 = 主表.合同金额*付款比例
        for (let index = 0; index < _this.subForms.length; index++) {
          let ref = _this.$refs['sub-form-' + _this.subForms[index].key];
          if(ref && ref[0]){
            if(!activeTab){
              activeTab = 'subForm'+(index+1);

            }
            if(_this.activeTab === ('subForm'+(index+1))){
              isOld = true;
            }
            ref[0].handlerMainDataChange(column, value);
          }
        }
        if(!isOld && activeTab){
          _this.activeTab = activeTab;
        }
      });

      // console.info(this.mainData)
    },
    handlerFileUploadSuccess (column, file) { // 文件上传成功回调

      if(column.widgetType === 'full-editor'){
        //console.log('-----handlerFileUploadSuccess----',this.fullEditor);
        let quill = this.fullEditor.quill;
        let selection = this.fullEditorSelection;

        //console.log('--selection---',selection);
        let url = getTempShareLookUrl(file.data.id,false,file.data.fileName);
        //let url = getTempShareLookSimpleUrl(file.data.id,false,file.data.fileName);
        quill.insertEmbed(selection.index, 'image', url);



        return;
      }

      this.mainData[column.columnName] = file.data.id;
      // 判断是否有关联附件
      let sourceFileData = this.sourceFileData[column.columnName];
      if (sourceFileData) {
        let desColumnName = sourceFileData.desColumnName;
        let fieldCn = sourceFileData.fieldCn;
        let desColumn = this.formColumnsMap[desColumnName];
        if (fieldCn === '文件名缩写') {
          this.mainData[desColumnName] = file.data.fileName.substring(0, file.data.fileName.lastIndexOf('.'));
          this._handlerValueChange(desColumn, this.mainData[desColumnName]);
        } else if (fieldCn === '文件名') {
          this.mainData[desColumnName] = file.data.fileName;
          this._handlerValueChange(desColumn, this.mainData[desColumnName]);
        } else if (fieldCn === '第1页截图') {
          // console.log('-------handlerFileUploadSuccess---------',file)
          let image = file.data.image;
          if (desColumn.widgetType === 'file' && image) {
            this.mainData[desColumnName] = image.id;
            let uploading = this.$refs['uploading_' + desColumnName];
            if (uploading) {
              if (uploading.length > 0) {
                uploading = uploading[0];
              }
              uploading.removeFiles();
              uploading.insertFile(image);
            }
          }

          this._handlerValueChange(desColumn, this.mainData[desColumnName]);
        }
      }
    },
    handlerFileLoaded (column, fileList) { // 文件加载完成
      // console.log('----------',column,fileList)/
      if (fileList && fileList.length > 0) {
        this.mainData[column.columnName] = fileList[fileList.length - 1].id;
      }
    },
    handleTabClick (tab, event) { // 多个明细表切换时触发

    },
    handlerSummaryChange (subForm, summaryData) { // 明细表合计数据发生变化时触发
      // console.info(subForm.title+'-----------'+JSON.stringify(summaryData))

      // 判断如果是编辑表单第一次渲染则不执行向上出发合计，不然会导致编辑表单修改的数据被修改
      if(this.ifFormEditRender){
        return;
      }

      let title = subForm.title;
      // 判断主表中是否有关联明细表计算的 ， 来源类型为明细表统计
      if (this.subFormSummary) {
        // console.log(title+'-----handlerSummaryChange-------',subForm, summaryData,this.subFormSummary)

        for (let desColumnName in this.subFormSummary) {
          let sourceAttr = this.subFormSummary[desColumnName];
          // console.log('------------',sourceAttr,(sourceAttr.indexOf(title) > -1 && sourceAttr.indexOf('[') > -1 && sourceAttr.indexOf(']') > -1))

          if (sourceAttr.indexOf(title) > -1 && sourceAttr.indexOf('[') > -1 && sourceAttr.indexOf(']') > -1) {
            // 计算公式，比如多个明细表相加
            let keys = sourceAttr.match(/\[(.*?)\]/gi); // 匹配所有类似[项目名称]的变量
            if (keys) {
              keys.forEach(key => {
                let newKey = key.trim().substring(key.indexOf('[') + 1, key.indexOf(']'));

                let keyArray = newKey.split('.');
                let subFormKey = keyArray[0];
                let columnName = keyArray[1];
                // console.log('-----------', subFormKey, columnName)
                let findSubFormConfig = this.subForms.find(subFormConfig => {
                  if (subFormConfig.title === subFormKey) {
                    return subForm;
                  }
                });
                let findSubForm = this.$refs['sub-form-' + findSubFormConfig.key][0];
                // console.log('-------findSubForm--------',('sub-form-' + findSubFormConfig.key), findSubForm)
                let findSummaryData = findSubForm.getSummaryData();
                let value = findSummaryData[columnName] || 0;
                sourceAttr = sourceAttr.replace(key, value);
              });
            }

            var result = 0;
            // console.log('-------result------'+'result = ' + sourceAttr)
            eval('result = ' + sourceAttr);
            /* if(true){
              console.log('-------result------'+'result = ' + sourceAttr)

              continue
            } */

            if (typeof result !== 'string') {
              result = this.toFixed(result);
              /* if(true){
                console.log(result+'-------result------'+'result = ' + sourceAttr)

                continue
              } */
            }
            this.mainData[desColumnName] = result;

            let column = this.formColumnsMap[desColumnName];
            // 触发change事件
            this._handlerValueChange(column, this.mainData[desColumnName]);
          } else {
            // 单个明细表
            if (sourceAttr.startsWith(title)) {
              let sourceAttrArray = sourceAttr.split('.');
              let columnName = sourceAttrArray[1];
              // console.info(key+'------'+columnName);
              if (summaryData[columnName] != undefined) {
                this.mainData[desColumnName] = summaryData[columnName];
                let column = this.formColumnsMap[desColumnName];
                // 触发change事件
                this._handlerValueChange(column, this.mainData[desColumnName]);
              }
            }
          }
        }
      }
    },
    getSubForm (key) { // 获取明细表组件
      let subForms = this.$refs['sub-form-' + key];
      if (subForms && subForms.length > 0) {
        return subForms[0];
      } else {
        return null;
      }
    },
    getFileColumns () { // 获取附件列
      return this.fileColumns;
    },
    deepSubFormData (config, data, tableData, parentNode) { // getData中组装明细表数据时 兼容明细表是树表组装数据
      // 自动给明细表增加排序
      let index = 0;
      let columns = config.queryColumns;
      let rule = config.rule;
      data.forEach(i => {
        let item = {...i};
        item['SORT_'] = ++index;
        // 判断是否有回填规则或者默认值
        if (rule) {
          for (let columnName in rule) {
            let key = rule[columnName];
            // 判断key是否常量
            if (key != undefined && String(key).indexOf('{') === -1 && this.validUtil.isNull(item[key])) {
              item[columnName] = key;
            } else {
              item[columnName] = item[key];
            }
          }
        }
        // 如果是树表设置上级
        if (config.isTree) {
          item[config.parentColumn] = parentNode ? parentNode['id'] : config.rootId;
        } else {
          // 删除之前添加的id
          delete item.id;
        }
        let filesData = [];
        let deleteFilesData = [];
        // 判断是否有日期时间字段，如果有，则把LABEL_格式化后的值赋
        columns.forEach(column => {
          // console.log('-----------------',column.columnName+'isShow',item[column.columnName+'isShow'])
          delete item[column.columnName + 'isShow'];
          if (column.widgetType == 'select-date' || column.widgetType == 'select-time' || column.widgetType == 'select-date-time') {
            let value = item[column.columnName + 'LABEL_'];
            if (value) {
              item[column.columnName] = item[column.columnName + 'LABEL_'];
            }
          } else if (column.widgetType == 'file') {
            let filesList = item[column.columnName + 'filesList'] || [];
            let deleteFilesList = item[column.columnName + 'deleteFilesList'] || [];
            filesData = filesData.concat(filesList);
            deleteFilesData = deleteFilesData.concat(deleteFilesList);
          } if (typeof item[column.columnName] !== 'string' && (column.multiple == 1 && (column.widgetType == 'select' || column.widgetType == 'select-dic' || column.widgetType == 'select-sql'))) {
            let str = '';
            item[column.columnName].forEach(item => { str += item + ','; });
            if (str) {
              str = str.slice(0, str.length - 1);
            }
            item[column.columnName] = str;
          } else if (column.widgetType === 'select-user-list' || column.widgetType === 'select-role-list' || column.widgetType === 'select-depart-list' || column.widgetType === 'select-project-member') {
            var subForms = {
              subFormForeignKey: column.subFormForeignKey, // 明细表中外键，对应主表主键
              subFormTable: column.tableName// 明细表数据库表名
            };
            let edit = item[column.columnName];
            if (typeof edit !== 'object') {
              edit = [];
            }
            // 自动给明细表增加排序
            let index = 0;
            if (edit && edit.length > 0) {
              edit.forEach(item => {
                item['SORT_'] = ++index;
              });
            }
            delete item[column.columnName];
            if (edit && edit.length > 0) {
              subForms['data'] = JSON.stringify(edit);
              subFormData.push(subForms);
            }
          } else if (column.widgetType === 'sub-form') {
            var c = item.subFormConfig;
            // console.log(column.title+'-------------',c)
            if (c) {
              let srcTableData = c.tableData || [];
              let subForm = {
                subFormForeignKey: c.subFormForeignKey, // 明细表中外键，对应主表主键
                subFormTable: c.tableName // 明细表数据库表名
              };
              let tableData = [];
              // console.log('-------columns--------'+element.config.queryColumns)
              if (srcTableData && srcTableData.length > 0) {
                // 递归组装明细表数据
                this.deepSubFormData(c, srcTableData, tableData);
              }
              subForm.data = JSON.stringify(tableData);
              let subForms = [subForm];
              item.subFormData = JSON.stringify(subForms);
              // console.log(column.title+'-------2------',item)
            }
          }
        });
        // 保存明细表附件
        if (filesData.length > 0) {
          item['filesData'] = JSON.stringify(filesData);
        }
        item['deleteFilesData'] = deleteFilesData;

        // 判断是否还有一层子表，要删除，否则json处理报错
        if (item.subFormConfig) {
          delete item.subFormConfig;
        }

        tableData.push(item);

        // 遍历下级数据
        if (item['children'] && item['children'].length > 0) {
          // 递归组装明细表数据
          this.deepSubFormData(config, item['children'], tableData, item);
        }
      });
    },
    getData () {
      // console.log('-------getData------')
      var subFormData = new Array();
      // 处理多个明细表配置同一个数据库表的逻辑
      let subFormMap = {};
      if (this.subForms) {
        for(let index = 0;index<this.subForms.length;index++){
          let element = this.subForms[index];
          let ref = this.$refs['sub-form-' + element.key];
          if(!ref || !ref[0]){
            continue;
          }
          // 如果非静默才可以保存
          if (element.silence === undefined || element.silence === 0) {
            // 单个明细表对象
            var subForm = {
              subFormForeignKey: element.config.subFormForeignKey, // 明细表中外键，对应主表主键
              subFormTable: element.config.tableName// 明细表数据库表名
            };
            let rule;
            // 判断是否明细表配置了控件参数,在其中配置了字段规则
            if (this.validUtil.isNotNull(element.attr)) {
              try {
                let attr = JSON.parse(element.attr);
                if (attr && attr['rule']) {
                  rule = attr['rule'];
                }
              } catch (e) {
                console.log('-----getData-解析明细表控件参数---------', e);
              }
            }
            element.config.rule = rule;
            // 传递是否树表
            subForm.isTree = element.config.isTree;
            subForm.rootId = element.config.rootId;
            subForm.parentColumn = element.config.parentColumn;
            let tableData = [];
            // console.log('-------columns--------'+element.config.queryColumns)
            if (element.config.tableData && element.config.tableData.length > 0) {
              // 递归组装明细表数据
              this.deepSubFormData(element.config, element.config.tableData, tableData);
            }
            // console.log('-------getData------',element.config,tableData)
            // 判断是否之前有相同的明细表已经保存过
            let tempSubForm = subFormMap[subForm.subFormTable];
            if (tempSubForm) {
              let data = JSON.parse(tempSubForm['data']);
              data = data.concat(tableData);
              tempSubForm['data'] = JSON.stringify(data);
            } else {
              // 单个明细表数据List<Map<String,Object>>的json字符串
              subForm['data'] = JSON.stringify(tableData);
              // 明细表对象数组
              subFormData.push(subForm);
              subFormMap[subForm.subFormTable] = subForm;
            }
          }
        }
      }
      // console.log('-------subFormData-------', subFormData)
      if (this.mainData['PROC_STATUS_']) {
        delete this.mainData['PROC_STATUS_'];
      }
      let fullEditorColumn = null;
      this.formColumns.forEach(column => {
        if (column.widgetType === 'select-user-list' || column.widgetType === 'select-project-member' || column.widgetType === 'select-role-list' || column.widgetType === 'select-depart-list') {
          var subForm = {
            subFormForeignKey: column.subFormForeignKey, // 明细表中外键，对应主表主键
            subFormTable: column.tableName// 明细表数据库表名
          };
          let tableData = this.mainData[column.columnName];
          if (typeof tableData !== 'object') {
            tableData = [];
          }

          // 自动给明细表增加排序
          let index = 0;
          if (tableData && tableData.length > 0) {
            tableData.forEach(item => {
              item['SORT_'] = ++index;
            });
          }
          // 判断是否之前有相同的明细表已经保存过
          let tempSubForm = subFormMap[subForm.subFormTable];
          // console.log('-----user-------', subFormMap, subForm, subFormData)
          if (tempSubForm) {
            let data = JSON.parse(tempSubForm['data']);
            data = data.concat(tableData);
            tempSubForm['data'] = JSON.stringify(data);
          } else {
            // 单个明细表数据List<Map<String,Object>>的json字符串
            subForm['data'] = JSON.stringify(tableData);
            subFormData.push(subForm);
            subFormMap[subForm.subFormTable] = subForm;
          }
        }else if(column.widgetType === 'full-editor'){
          fullEditorColumn = column;
        }
        if (column.widgetType === 'radio') {
          this.mainData[column.columnName] = this.mainData[column.columnName + 'LABEL_'];
        }
        // 如果为省市级联
        if (column.widgetType === 'select-cascade') {
          var subForm = {
            subFormForeignKey: column.subFormForeignKey, // 明细表中外键，对应主表主键
            subFormTable: column.tableName// 明细表数据库表名
          };
          let cascade = this.$refs[column.columnName + 'cascade'];
          if (cascade && cascade[0]) {
            cascade = cascade[0];
            // let tableData = {}
            let tableData = cascade.getCheckedNodes()[0];
            // 自动给明细表增加排序
            let sort = 1;
            let subData = [];
            if (tableData && tableData.path) {
              tableData.path.forEach(item => {
                subData.push({'SORT_': sort, 'PARENT_ID_': item, 'COLUMN_ID_': column.id, 'VALUE_': tableData.pathLabels[sort - 1]});
                sort++;
              });
              this.mainData[column.columnName] = cascade.inputValue;
            } else {
              tableData = this.mainData[column.columnName + 'cascade'];
              if (tableData && tableData.length > 0) {
                tableData.forEach(item => {
                  subData.push({'SORT_': sort, 'PARENT_ID_': item.value, 'COLUMN_ID_': column.id, 'VALUE_': item.label});
                  sort++;
                });
              }
            }
            subForm['data'] = JSON.stringify(subData);
            subFormData.push(subForm);
          }
        }
        // 如果为风险提示级联选择
        if (column.widgetType === 'cascader') {
          let cascadeData = this.mainData[column.columnName + 'cascade'];
          if (cascadeData && cascadeData.length > 0) {
            this.mainData[column.columnName]=cascadeData.join(",")
          }
          
        }
        if (column.widgetType === 'select' || column.widgetType === 'select-sql' || column.widgetType === 'select-dic') {
          // this.mainData[column.columnName] = this.mainData[column.columnName + 'LABEL_']
          // 如果是多选
          if (column.multiple === 1) {
            let options = this.mainData[column.columnName + 'LABEL_'];
            let str = '';
            if (options && options.length > 0) {
              for (let i = 0; i < options.length; i++) {
                if (i != 0) {
                  str += ',';
                }
                str += options[i];
              }
            }
            this.mainData[column.columnName] = str;
          }
        }
        if (column.widgetType === 'checkbox') {
          // this.mainData[column.columnName] = this.mainData[column.columnName + 'LABEL_']
          // 如果是多选
          let options = this.mainData[column.columnName + 'LABEL_'];
          let str = '';
          if (options && options.length > 0) {
            for (let i = 0; i < options.length; i++) {
              if (i != 0) {
                str += ',';
              }
              str += options[i];
            }
          }
          this.mainData[column.columnName] = str;
        }
        if (column.widgetType === 'select-time') {
            //解决保存时间后，日期还是旧的问题
          if (this.mainData[column.columnName + 'LABEL_']) {
            this.mainData[column.columnName + 'LABEL_'] = this.mainData[column.columnName];
          }
          // 解决时间控件清空数据无法保存问题
          if (!this.mainData[column.columnName]) this.mainData[column.columnName] = '';
        }
        // 如果是时间格式
        if (column.widgetType === 'select-date' && typeof this.mainData[column.columnName] !== 'string') {
          let format = 'yyyy-MM-dd';
          if (column.dateType === 'year') {
            format = 'yyyy';
          } if (column.dateType === 'month') {
            format = 'yyyy-MM';
          } if (column.dateType === 'datetime') {
            format = 'yyyy-MM-dd hh:mm:ss';
          }
          let value = this.mainData[column.columnName];
          if (typeof this.mainData[column.columnName] === 'number') {
            value = new Date(this.mainData[column.columnName]);
          }
          this.mainData[column.columnName] = (!value ? '' : value.format(format));
        }
      });

      // console.log('-----final-------', subFormData)
      var mainData = {...this.mainData};// 主表数据，是Map<String,Object>

      for (let key in mainData) {
        if (typeof mainData[key] === 'object') {
          delete mainData[key];
        }
      }

      // 新增附件列表数组
      var filesList = [];
      // 删除附件id逗号隔开字符串
      var deleteFilesList = [];
      // console.info(this)
      // console.info(this.$refs)
      // 循环所有附件
      this.formColumns.forEach(column => {
        // console.log( column.columnName+'-----------',column.widgetType,column.silence)
        if (column.widgetType === 'file' && (column.silence === undefined || column.silence === 0)) {
          // console.info('-----uploading_------' + 'uploading_' + column.columnName)
          let uploading = this.$refs['uploading_' + column.columnName];
          // console.info(uploading === undefined || uploading.length === 0?'--空--':'--有值---')
          if (uploading) {
            if (uploading.length > 0) {
              uploading = uploading[0];
            }
            // console.info(uploading.filesList)
            if(uploading.getFilesList){
              let fileList = uploading.getFilesList();
              // console.info('-----fileList-----'+fileList)
              if (fileList) {
                filesList = filesList.concat(fileList);
              }
              if (uploading.deleteFilesList) {
                deleteFilesList = deleteFilesList.concat(uploading.deleteFilesList);
              }
            }
          }
        }
      });
      // 处理富文本
      if(fullEditorColumn){
        let html = this.getEditorData(fullEditorColumn);
        this.mainData[fullEditorColumn.columnName] = html;
        mainData[fullEditorColumn.columnName] = html;
        // console.log('--fullEditorColumn--'+this.mainData[fullEditorColumn.columnName]);
        // let uploading = this.$refs['uploading_full-editor'];
        let uploading = this.$refs['full-editor-'+fullEditorColumn.columnName];
        // console.info(uploading === undefined || uploading.length === 0?'--空--':'--有值---')
        if (uploading) {
          if (uploading.length > 0 ) {
            uploading = uploading[0];
          }
          if(uploading.getFilesList){
            let pictureFileList = uploading.getFilesList();
            // console.info('-----fileList-----'+fileList)
            if (pictureFileList) {
              filesList = filesList.concat(pictureFileList);
            }
            let pictureDeleteFileList = uploading.getDeleteFilesList();
            if (pictureDeleteFileList) {
              deleteFilesList = deleteFilesList.concat(pictureDeleteFileList);
            }
          }
          // console.info(uploading.filesList)

        }
      }

      // console.log(subFormData)
      // console.log('----getData---'+mainData['CONTENT_'])
      var params = {
        sqlTableName: this.defaultConfig.tableName, // 主表数据库表名
        // mainFormData: JSON.stringify(mainData),//主表数据，map的json字符串，兼容老版本
        mainFormDataMap: mainData, // 主表数据,map对象
        subFormData: JSON.stringify(subFormData), // 明细表数组的json字符串
        filesList: filesList, // 新增附件列表数组
        deleteFilesList: deleteFilesList, // 删除附件id逗号隔开字符串
        ifSaveWorkflow: false// 是否执行流程，如果是，保存完业务数据后，自动调用流程提交;如果否只是执行保存业务数据
      };
      // 组装摘要
      if (this.defaultConfig.abstracts) {
        let abstracts = this.defaultConfig.abstracts;
        let keys = abstracts.match(/\{(.*?)\}/gi); // 匹配所有类似[项目名称]的变量
        if (keys) {
          keys.forEach(key => {
            let columnName = key.trim().substring(key.indexOf('{') + 1, key.indexOf('}'));
            // console.log(key+'----------'+columnName)
            let column = this.formColumnsMap[columnName];
            let value = '';
            if (column) {
              if (column.widgetType && (column.widgetType === 'select-form' || column.widgetType === 'select-user' || column.widgetType === 'select-role' || column.widgetType === 'select-depart')) {
                value = this.mainData[columnName + 'LABEL_'] || this.mainData[columnName];
              } else if (column.widgetType && (column.widgetType === 'select' || column.widgetType === 'select-dic' || column.widgetType === 'select-sql')) {
                if (column.options) {
                  let options = column.options.find(item => {
                    if (item.value === this.mainData[columnName]) {
                      return item;
                    }
                  });
                  value = options ? options.name : this.mainData[columnName];
                }
              } else {
                value = this.mainData[columnName];
              }
            } else {
              value = this.getConstValue(columnName);
            }
            value = (this.validUtil.isNotNull(value) ? value : '');
            abstracts = abstracts.replace(new RegExp(key, 'gm'), value);
          });
        }
        params['abstracts'] = abstracts;
      }
      let businessKey = this.defaultConfig.businessKey;
      if (this.validUtil.isNotNull(businessKey)) {
        params['id'] = businessKey;// 业务数据主键
        params['businessKey'] = businessKey;// 业务数据主键，流程用到
      }
      params['currentUserUid'] = this.sessionUtil.getUserUid();
      params['currentUserName'] = this.sessionUtil.getUserName();
      params['currentUserId'] = this.sessionUtil.getUserId();
      if (this.validUtil.isNotNull(this.defaultConfig.formKey)) {
        params['formKey'] = this.defaultConfig.formKey;// 业务表单key
      }
      params['subject'] = this.mainData['TITLE_'] || this.mainData['SUBJECT_'];
      params['title'] = this.defaultConfig.title;
      params['formId'] = this.formId;
      params['formInfoId'] = this.formInfoId;
      // console.log('-------getData-------',params)
      return params;
    },
    mask () {
      // console.log('------mask-----')
      this.loading = true;
    },
    unmask () {
      // console.log('------unmask-----')
      this.loading = false;
    },
    hideProcessMonitor () {
      this.processMonitorVisible = false;
    },
    initProcess () { // 流程初始化
      this.processForm = this.$refs['process-form'];
      if (this.processForm) {
        this.processForm.initProcess();
      }
      let processMonitor = this.$refs['process-monitor'];
      if (processMonitor && this.validUtil.isNotNull(this.businessKey)) {
        // console.log('----------processMonitor-----------')
        processMonitor.initProcess(this.businessKey);
      }
      // console.info(this.$refs)
      // console.info(this.$refs['mainForm'])
      // console.info(this.$refs+'-------------'+this.$refs['process-form'])
    },
    checkValidSubForm (form, data) { // 验证明细表
      let config = form.config;
      let _this = this;
      let ref = _this.$refs['sub-form-' + form.key];
      if(ref){
        ref = ref[0];
      }
      let validFlag = true;
      if (!data) data = [];

      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        let noValue = true;
        for (let j = 0; j < config.queryColumns.length; j++) {
          const column = config.queryColumns[j];
          let value = element[column.columnName];
          if (value != undefined && value != '' && column.columnName != 'SORT_') { // 最后判断子表是否有空数据
            noValue = false;
          }
        }
        // 如果整行都为空
        if (noValue) {
          data.splice(i, 1);
        }
      }
      // 校验必填
      if (form.require && data.length === 0) {
        // 非空校验
        if (form.validMessage) {
          _this.util.warn(form.validMessage);
        } else {
          _this.util.warn('明细表' + form.title + '不能为空');
        }
        return false;
      }
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        let flag = true;
        let msg = '';
        for (let j = 0; j < config.queryColumns.length; j++) {
          const column = config.queryColumns[j];
          let value = element[column.columnName];
          let required = column.require;
          // 判断列是否隐藏
          // console.log('----ref----',ref);
          // 如果是明细表中嵌套明细表ref是不存在的
          let c = null;
          if(ref){
            c = ref.columnsMap[column.columnName];
            // console.log(column.title+'--------',c.visible,column.visible,c,column);
            if(!c.visible){
              required = 0;
            }
          }else{
            c = {...column};
            c.visible = c.hidden!= undefined && c.hidden == 1?false:true;
          }

          // 优先判断流程配置权限
          if (this.authsMap && this.authsMap[config.id] && (this.authsMap[config.id][column.columnName] == 4)) {
            required = 1;
          }
          // console.log(column.columnName+'----required----',value,required)
          // 先判断是否有必填项未填
          if (required === 1) {
            if (column.javaType === 'Double' || column.javaType === 'Integer') {
              if (value === undefined || value === '') {
                msg = config.title + '第' + (i + 1) + '行' + column.title + '未填写';
                validFlag = false;
                flag = false;
              }
            } else {
              if (!value || value === '') {
                msg = config.title + '第' + (i + 1) + '行' + column.title + '未填写';
                validFlag = false;
                flag = false;
              }
            }
          }
          // 判断是否是整型
          if (value && (column.javaType === 'Double' || column.javaType === 'Integer')) {
            const numValue = Number(value);
            if (isNaN(numValue)) {
              msg = config.title + '第' + (i + 1) + '行' + column.title + '格式不正确';
              validFlag = false;
              flag = false;
            }
          }
          // console.log(column.columnName+'-----------',!c.visible,column.validRule);
          // 如果当前是隐藏，则不进行校验
          if (c.visible && column.validRule) {
            let validRule = column.validRule;
            // console.log('--------validRule----1----',validRule)
            for (let j = 0; j < config.queryColumns.length; j++) {
              const edit = config.queryColumns[j];
              if (validRule.indexOf(edit.columnName) > -1) {
                let value = element[edit.columnName];
                if (this.validUtil.isNull(value)) {
                  if (edit.javaType === 'Double' || edit.javaType === 'Integer') {
                    value = 0;
                  } else {
                    value = '';
                  }
                } else {
                  if (edit.javaType === 'Double' || edit.javaType === 'Integer') {
                    value = parseFloat(value);
                  } else {
                    if (validRule.indexOf('"{' + edit.columnName) > -1) {

                    } else {
                      value = '"' + value + '"';
                    }
                  }
                }
                validRule = validRule.replace(new RegExp('{' + edit.columnName + '}', 'gm'), value);
              }
            }
            console.log('--------validRule--------',validRule)
            //判断是否正则表达式验证
            if (validRule.indexOf('/^') > -1) {
              var regExp = undefined;
              eval('regExp='+validRule);
              let re = new RegExp(eval(validRule));
              if (!re.test(value)) {
                msg = config.title + '第' + (i + 1) + '行:' + column.validMessage;
                flag = false;
                validFlag = false;
              }
            }
            if (!eval(validRule)) {
              // console.log(column.validRule,'----error----',validRule)
              msg = config.title + '第' + (i + 1) + '行' + column.validMessage;
              flag = false;
              validFlag = false;
              break;
            }
          }
        }
        // console.log(column.title+'------value-------',element,column,value)
        // 验证明细表中的明细表
        if (element && element.subFormConfig) {
          let childFlag = _this.checkValidSubForm({config: element.subFormConfig}, element.subFormConfig.tableData);
          if (!childFlag) {
            validFlag = false;
            break;
          }
        }
        if (!flag) {
          _this.util.warn(msg);
          validFlag = false;
          break;
        }

        // 如果是树表则验证下级
        if (element['children'] && element['children'].length > 0) {
          let childFlag = _this.checkValidSubForm(form, element['children']);
          if (!childFlag) {
            validFlag = false;
            break;
          }
        }
      }

      return validFlag;
    },
    formValidate (a, b, c) {
      // console.log('-------formValidate------', a, b, c)
    },
    checkValid () { // 表单校验
      let _this = this;
      // 先调用一次获取数据
      _this.getData();
      // console.info(this.mainData);
      // console.info(this.rules);
      var p = new Promise(function (resolve, reject) {
        // console.info('-----1-----');
        let validFlag = true;
        // 保存已经托管到process-form
        _this.$refs['mainForm'].validate((valid) => { // 先判断主表是否填写正确
          if (valid) {
            let msg = null;
            // console.info('-----2-----');
            // 主表自定义校验规则
            if (_this.formColumns) {
              let mainData = _this.mainData;
              for (let i = 0; i < _this.formColumns.length; i++) {
                let column = _this.formColumns[i];
                validFlag = _this.checkFieldValid(column);
                if (!validFlag) {
                  msg = column.validMessage;
                  break;
                }
              }
            }
            if (msg) {
              _this.util.warn(msg);
            }
            // 子表自定义校验规则
            if (_this.subForms) {
              for (let i = 0; i < _this.subForms.length; i++) {
                let form = _this.subForms[i];
                let ref = _this.$refs['sub-form-' + form.key];
                if(!ref || !ref[0]){
                  continue;
                }
                let flag = _this.checkValidSubForm(form, form.config.tableData);
                if (!flag) {
                  validFlag = false;
                  break;
                }
                // 判断是否配置了jsCode
                var jsCode = form.config.jsCode;
                // jsCode= 'customCheckValid = function(data,vm){console.log(data,vm);}';
                if(_this.validUtil.isNotNull(jsCode)){
                  var checkSubFormValid = undefined;
                  //var test = undefined;
                  //var testStr = 'test = function(data,vm){console.log(data,vm);alert(1);}';
                  //eval(testStr);
                  // test();
                  //let result = test(form.config.tableData,_this);
                  // console.log('=============',jsCode);
                  eval(jsCode);
                  if(checkSubFormValid){
                    let r = checkSubFormValid(form.config.tableData,form.config,_this);
                    if(!r.ok){
                      _this.util.warn(r.msg);
                      validFlag = false;
                      break;
                    }
                  }
                }
              }
            }
            if (validFlag) {
              resolve();
            } else {
              reject();
            }
          } else {
            _this.util.warn('提示！数据录入不完整，请检查！');
            reject('提示！数据录入不完整，请检查！');
          }
        });
      });
      return p;
    },
    submit (type) { // 按钮触发函数
      let _this = this;

      if (type === -2) {
        this.util.confirm('反核销将只删除流程审批数据，确定要反核销吗？', '提示', () => {
          deleteData({businessKey: this.defaultConfig.businessKey, sqlTableName: this.defaultConfig.tableName}).then(() => {
            _this.util.success('反核销成功！');
            _this.rollbackDataBtnVisible = false;
            if (_this.saveDataCallback != undefined) {
              _this.saveDataCallback(type);
            }
          });
        });
        return;
      }
      // console.info(this.defaultConfig.parent)
      // 如果是打印
      // 判断是否跳转打印页面
      if (type === 9 || type === 10) {
        if (this.sessionUtil.isCloud() && !this.sessionUtil.isProVersion()) {
          this.$bus.emit('on-show-license-msg', 4);
          return false;
        }

        let formConfig = {..._this.defaultConfig};
        let param = {
          'businessKey': this.businessKey,
          'type': '2',
          'formInfoId': formConfig.id
        };
        this.subList = [];
        formConfig.formColumns = formConfig.formColumns.filter(e => {
          if (e.widgetType === 'sub-form') {
            // 删除子表关联parent
            this.subList.push(e);
          }
          return e.widgetType !== 'sub-form';
        });
        this.html5Params = {
          formConfig: formConfig,
          subConfig: this.subList[0],
          data: this.mainData,
          type: '2',
          formId: formConfig.formId,
          formInfoId: formConfig.id,
          jsCode: null
        };
        this.getFlowData();
        setTimeout(() => {
          getReport(param, this).then(data => {
            if (data) {
              this.grfType = true;
              // 如果有多个模板
              if (data.length > 1) {
                let sysList = data.filter(item => {
                  return item.category !== 1;
                });
                let userList = data.filter(item => {
                  return item.category === 1;
                });
                if (userList && userList.length > 0) {
                  this.modalList = userList;
                } else {
                  this.modalList = sysList;
                }
                this.selectModalVisible = true;
              } else {
                // 判断是否需要组装流程数据
                let grf = data[0].grf;
                if (data[0].joinWorkFlow == 1) {
                  let foot = utils.getWfRepoft(this.flowList, this.ImageList);
                  grf = JSON.parse(grf);
                  if (foot.ReportFooter) {
                    grf.ReportFooter = [foot.ReportFooter];
                  }
                  if (foot.Parameter && foot.Parameter.length > 0) {
                    grf.Parameter = grf.Parameter.concat(foot.Parameter);
                  }
                  grf = JSON.stringify(grf);
                }
                // 设置自定义脚本
                if (this.validUtil.isNotNull(data[0].jsCode)) {
                  this.html5Params.jsCode = data[0].jsCode;
                }
                this.html5Params.grf = grf;
                this.getFormData();
                this.openReport();
              }
            } else {
              this.grfType = false;
              // 如果有多个子表
              /* if (this.subList.length > 1) {
                this.modalList = this.subList
                this.selectModalVisible = true
              } else {
                // console.log(this.flowData, '`flowDataflowDataflowData`')
                this.html5Params.grf = JSON.stringify(utils.getReport(formConfig, 2, this.subList[0], this.flowList, this.ImageList))
                this.getFormData()
                this.openReport()
              } */
              this.html5Params.config = {formConfig, subList: this.subList, wfData: this.wfData, signData: this.signData, flowList: this.flowList, imageList: this.ImageList};
              this.getFormData();
              this.openReport();
            }
          });
        }, 1000);
        return;
      } else if (type === 0 || type != -1) {
        // console.log(type+'------_this.defaultConfig.parent-----',_this.defaultConfig.parent,_this.defaultConfig.parent.closeForm)
        // console.log(this.$route, '_this.defaultConfig')
        // this.$bus.emit('app-main-on-tab-close', this.$route.path)
        // return
        // 判断是否通过ws消息直接打开
        if (this.$route && this.$route.query && this.$route.query._isOpenPage) {
          this.$bus.emit('app-main-on-tab-close', this.$route.path);
        }
        if (_this.defaultConfig.parent && _this.defaultConfig.parent.closeForm) {
          _this.subFormsVisible = false;
          _this.defaultConfig.parent.closeForm();
        }
        // 判断是否是openDialog进来
        if (this.openConfig && this.openConfig.parent && this.openConfig.parent.closeOpenDialog) {
          this.openConfig.parent.closeOpenDialog();
        } else {
          // console.log(this.$route.path)
          // 判断是否直接打开表单
          if (this.$route.path && this.$route.path.indexOf('/form/edit/') > -1) {
            // 如果是待办、待阅、和申请等页面穿透，返回直接跳转到列表页面
            /* let path = this.$route.path.replace('/edit/', '/query/')
            this.$router.push(path) */
            this.$router.go(-1);
          }
        }

        if (type === -1) {
          // 刷新父页面数据
          if (_this.defaultConfig.parent && _this.defaultConfig.parent.loadData) {
            _this.defaultConfig.parent.loadData(null, false);
          }
        }
        return;
      }
      this.checkValid().then(() => {
        _this.submitData(); // 保存数据
      });
    },
    openReport () {
      // console.log('-------openReport-------')
      if (this.sessionUtil.isCloud() && !this.sessionUtil.isProVersion()) {
        this.$bus.emit('on-show-license-msg', 4);
        return false;
      }
      // 如果配置并且上传了报表文件 则默认客户端启动
      if (this.grfType) {
        // setTimeout(() => {
        // 由于需要加载流程图片信息 需要延时加载
        if (this.ImageList && this.html5Params.grf) {
          this.html5Params.grf = JSON.parse(this.html5Params.grf);
          this.html5Params.grf.ImageList = this.ImageList;
          this.html5Params.grf = JSON.stringify(this.html5Params.grf);
        }
        // debugger
        // 直接启动报表客户端打印
        if (this.html5Params.grf && this.html5Params.data) {
          // 执行自定义脚本,重新组装数据
          var data = this.html5Params.data;
          var beforeRenderData = undefined;
          var jsCode = this.html5Params.jsCode;
          if (this.validUtil.isNotNull(jsCode)) {
            eval(jsCode);
            if (beforeRenderData) {
              beforeRenderData(data);
            }
          }

          webapp.webapp_urlprotocol_startup();
          let grfJson = webapp.webapp_register(this.html5Params.grf);
          // console.log('-------222--------',grfJson)

          console.log('-- form-edit---openReport----', grfJson, data);
          webapp.webapp_ws_run({}, grfJson, JSON.stringify(data));
        }
        // }, 500)
      } else {
        getReportType(this).then(res => {
          // 0为服务端 1为客户端
          setTimeout(() => {
            // 由于需要加载流程图片信息 需要延时加载
            if (this.ImageList && this.html5Params.grf) {
              this.html5Params.grf = JSON.parse(this.html5Params.grf);
              this.html5Params.grf.ImageList = this.ImageList;
              this.html5Params.grf = JSON.stringify(this.html5Params.grf);
            }
            if (res.data == '1') {
              // 生成新的grf
              let config = this.html5Params.config;
              this.html5Params.grf = JSON.stringify(utils.getEditReport2(config.formConfig, config.subList, config.wfData, config.signData,this));
              console.log('---grf---',this.html5Params.data,this.html5Params, config, this.html5Params.grf);
              // console.log('=====data=====',JSON.stringify(this.html5Params.data));
              // 直接启动报表客户端打印
              if (this.html5Params.grf && this.html5Params.data) {
                webapp.webapp_urlprotocol_startup();
                let grfJson = webapp.webapp_register(this.html5Params.grf);
                webapp.webapp_ws_run({}, grfJson, JSON.stringify(this.html5Params.data));
              }
            } else {
              let params = {
                grf: this.html5Params.grf,
                config: this.html5Params.config,
                data: this.html5Params.data,
                fileName: this.title,
                isForm: true,
                vm: this
              };
              // html5+报表服务端打印
              this.$router.push({
                name: 'page-html5',
                params: params
              });
            }
          }, 500);
        });
      }
    },
    selectModal () {
      debugger;
      this.modalList.forEach(edit => {
        if (edit.selected === true) {
          if (edit.grf) {
            this.grfType = true;
            let grf = edit.grf;
            // 是否拼接流程
            if (edit.joinWorkFlow == 1) {
              let foot = utils.getWfRepoft(this.flowList, this.ImageList);
              grf = JSON.parse(grf);
              if (foot.ReportFooter) {
                grf.ReportFooter = [foot.ReportFooter];
              }
              if (foot.Parameter && foot.Parameter.length > 0) {
                grf.Parameter = grf.Parameter.concat(foot.Parameter);
              }
              grf = JSON.stringify(grf);
            }
            // 设置自定义脚本
            if (this.validUtil.isNotNull(edit.jsCode)) {
              this.$set(this.html5Params, 'jsCode', edit.jsCode);
            }
            this.$set(this.html5Params, 'grf', grf);
          } else {
            let grf = JSON.stringify(utils.getReport(this.html5Params.formConfig, 2, edit, this.flowList, this.ImageList));
            this.$set(this.html5Params, 'grf', grf);
            this.grfType = false;
          }
        }
      });
      this.getFormData();
      this.openReport();
    },
    encodeUtf8 (text) {
      const code = encodeURIComponent(text);
      const bytes = [];
      for (var i = 0; i < code.length; i++) {
        const c = code.charAt(i);
        if (c === '%') {
          const hex = code.charAt(i + 1) + code.charAt(i + 2);
          const hexVal = parseInt(hex, 16);
          bytes.push(hexVal);
          i += 2;
        } else bytes.push(c.charCodeAt(0));
      }
      return bytes;
    },
    getFormData () {
      let formConfig = this.defaultConfig;
      let data = JSON.parse(JSON.stringify(this.mainData));
      if (!data) return null;

      // 判断富文本
      this.formColumns.forEach(column => {
        if (column.widgetType) {
          if (column.widgetType === 'full-editor') {
            let html = data[column.columnName];
            // console.log(html.length+'-----html---1---',html)
            if (this.validUtil.isNotNull(html)) {
              html = html.replace(/<\/?.+?>/g, '');
              html = html.replace(/&nbsp;/g, ' ');
              data[column.columnName] = html;
              // console.log(html.length+'-----html---2---',html)
            }
          } else if (column.widgetType === 'number-permil') {
            // 如果是千分位
            data[column.columnName] = this.util.numToPermil(data[column.columnName]);
          } else if (column.widgetType === 'number-bank') {
            // 如果是银行卡号
            data[column.columnName] = this.util.numToBank(data[column.columnName]);
          }
        }
      });
      let result = {'Table': []};
      result.Table.push(this.filterData(data, formConfig));
      let subdata = [];

      // console.log('======subdata======',subdata);
      if (this.subList.length > 0) {
        let flag = true;
        this.subList.forEach(eidt => {
          if (eidt.selected === true) {
            flag = false;
            this.html5Params.formConfig.formColumns.push(eidt);
            subdata = this.filterSubData(eidt.config.tableData, eidt.config);
          }
        });
        if (flag) {
          this.html5Params.formConfig.formColumns.push(this.subList[0]);
          subdata = this.filterSubData(this.subList[0].config.tableData, this.subList[0].config);
        }
      }
      if (subdata.length > 0) {
        result.Detail1 = subdata;
      }else{
        if (this.subList.length == 1) {
          // 拼接一个空行，否则主表数据会填充到明细表
          let blankRow = {};
          this.subList[0].config.queryColumns.forEach(c=>{
            blankRow[c.columnName]='';
          });
          result.Detail1 = [blankRow];
        }
      }
      for (let index = 1; index < this.subList.length; index++) {
        let subData = this.filterSubData(this.subList[index].config.tableData, this.subList[index].config);
        result['Detail' + (index + 1)] = subData;
      }
      this.html5Params.data = result;
    },
    dicValue (column, value, dicMap) { // 数据字典label
      // console.info(column)
      // console.info(JSON.stringify(column))
      if (column) {
        // console.info('---column.columnName---'+column.columnName+'-------'+this.dicMap[column.columnName]+'-------'+value)
        // console.info(JSON.stringify(this.dicMap))
        if (dicMap && dicMap[column.columnName]) {
          // console.info('---dicMap[column.columnName]---'+JSON.stringify(this.dicMap[column.columnName]))
          // console.info(value+'-------'+this.dicMap[column.columnName][value+''])
          return dicMap[column.columnName][value];
        } else if (column.options) {
          // console.info('---dicMap[column.columnName]---'+JSON.stringify(this.dicMap[column.columnName]))
          // console.info(value+'-------'+this.dicMap[column.columnName][value+''])
          if (column.multiple === 1 && value) {
            if (typeof value === 'string') {
              value = value.split(',');
            }
            let str = '';
            value.forEach(v => {
              let e = column.options.find(item => {
                return item.value === v;
              });
              str = e ? str += e.name + ',' : str;
            });
            if (str) {
              value = str.slice(0, str.length - 1);
            }
          } else {
            let e = column.options.find(item => {
              return item.value === value;
            });
            value = e ? e.name : value;
          }
        }
        return;
      }
      return value || '';
    },
    // 过滤数据
    filterData (data, formConfig) {
      if (!data || !formConfig) return;
      formConfig.formColumns.forEach(e => {
        if (data[e.columnName + 'LABEL_']) {
          data[e.columnName] = data[e.columnName + 'LABEL_'];
          delete data[e.columnName + 'LABEL_'];
        }
        // 如果是时间控件
        if (e.widgetType === 'select-date' || e.widgetType === 'select-time' || e.widgetType === 'select-date-time') {
          let format = 'yyyy-MM-dd';
          if (e.widgetType === 'select-time') {
            format = 'HH:mm:ss';
          } else if (e.widgetType === 'select-date-time') {
            format = 'yyyy-MM-dd hh:mm:ss';
          }
          data[e.columnName] = this.formater(format, data[e.columnName]);
        }
        if (e.widgetType === 'select-dic' || e.widgetType === 'select-sql' || e.widgetType === 'select') {
          let str = '';
          if (e.options) {
            if (e.multiple === 1) {
              str = data[e.columnName];
            } else {
              let option = e.options.find(v => {
                return v.value == data[e.columnName];
              });
              if (option) {
                str = option.name;
              }
            }
          }
          data[e.columnName] = str;
          delete data[e.columnName + 'LABEL_'];
        }
        if (e.widgetType === 'checkbox') {
          let str = '';
          let options = data[e.columnName];
          if (options && options.length > 0) {
            for (let i = 0; i < options.length; i++) {
              if (i != 0) {
                str += ',';
              }
              str += options[i] ;//e.options[i].name;
            }
          }
          data[e.columnName] = str;
        }
        if (e.widgetType === 'select-user-list' || e.widgetType === 'select-project-member' || e.widgetType === 'select-role-list' || e.widgetType === 'select-depart-list') {
          let arr = data[e.columnName];
          let str = '';
          if (arr && arr.length > 0) {
            for (let index = 0; index < arr.length; index++) {
              if (index != 0) {
                str += ',';
              }
              str += (arr[index].userName || arr[index].roleName || arr[index].departName);
            }
          }
          data[e.columnName] = str;
        }
        if (e.widgetType === 'select-cascade') {
          data[e.columnName] = data[e.columnName + 'placeholder'];
          delete data[e.columnName + 'cascade'];
        }
        if (e.widgetType === 'file') {
          let uploading = this.$refs['uploading_' + e.columnName];
          if (uploading) {
            let fileArr = uploading[0].fileArr;
            let str = '';
            for (let index = 0; index < fileArr.length; index++) {
              if (index != 0) {
                str += ',';
              }
              str += fileArr[index].fileName;
            }
            data[e.columnName] = str;
          }
        }
        // 如果是switch控件 判断是否选中 默认1为是 0 为否
        if (e.widgetType === 'switch') {
          let activeValue = (e.options && e.options[1] !== undefined) ? e.options[1] : '是';
          let inActiveValue = (e.options && e.options[0] !== undefined) ? e.options[0] : '否';
          data[e.columnName] = (data[e.columnName + '_SWITCH'] == 'true') ? activeValue : inActiveValue;
        }
        // 如果是审批状态
        if (e.columnName === 'PROC_STATUS_') {
          if (data[e.columnName] === '-5' || data[e.columnName] === '已审') {
            data[e.columnName] = '已审';
          } else if (data[e.columnName] === '-1' || data[e.columnName] === '送审') {
            data[e.columnName] = '送审';
          } else {
            data[e.columnName] = '未审';
          }
        }
      });

      data = Object.assign(data, this.flowData);
      if (this.logoData) {
        data['SYS_COMPANY_LOGO'] = this.logoData;
      }
      // console.log('---data---',data, this.flowData,a)
      return data;
    },
    formater (format, value) {
      return this.util.format(format, value);
    },
    getFlowData () { // 打印时需要v
      let _this = this;
      if (this.mainData && this.mainData.ID_) {
        let params = {
          businessKey: this.mainData.ID_,
          flag: true
        };
        let data = {};
        let imageList = [];
        let flowList = [];
        if (this.squareLogo) {
          // 获取logo
          let logoParams = {
            id: this.squareLogo
          };
          getLogImg(logoParams).then(res2 => {
            if (res2) {
              this.logoData = res2;
            }
          });
        }
        getFlow(params).then(res => {
          if (res) {
            _this.wfData = res;
            let sings = [];
            for (let i = 0; i < res.length; i++) {
              if (res[i].children && res[i].children.length > 1) {
                res[i].children.forEach((element, index) => {
                  element.taskDefKey = res[i].taskDefKey + index;
                  flowList.push(element);
                  data['wf_assignee_' + element.taskDefKey] = element.assignee;
                  data['wf_assignee_' + element.name] = element.assignee;
                  if (element.sign) {
                    sings.push(element.sign);
                  }
                  data['wf_endTime_' + element.taskDefKey] = element.endTime;
                  data['wf_comment_' + element.taskDefKey] = element.comment || '无';
                  data['wf_node_' + element.taskDefKey] = res[i].name;
                  data['wf_endTime_' + element.name] = element.endTime;
                  data['wf_comment_' + element.name] = element.comment || '无';
                  data['wf_node_' + element.name] = res[i].name;
                  // 如果没有开始时间和审批人
                  if (!element.startTime && !element.assignee) {
                    data['wf_comment_' + element.taskDefKey] = '未审批';
                    data['wf_comment_' + element.name] = '未审批';
                  }
                });
              } else {
                flowList.push(res[i]);
              }
              data['wf_assignee_' + res[i].taskDefKey] = res[i].assignee;
              data['wf_assignee_' + res[i].name] = res[i].assignee;
              if (res[i].sign) {
                sings.push(res[i].sign);
              }
              data['wf_endTime_' + res[i].taskDefKey] = res[i].endTime;
              data['wf_comment_' + res[i].taskDefKey] = res[i].comment || '无';
              data['wf_node_' + res[i].taskDefKey] = res[i].name;
              data['wf_endTime_' + res[i].name] = res[i].endTime;
              data['wf_comment_' + res[i].name] = res[i].comment || '无';
              data['wf_node_' + res[i].name] = res[i].name;
              data[res[i].name + 'endTime'] = res[i].endTime;
              data[res[i].name + 'comment'] = res[i].comment || '无';
              data[res[i].name + 'node'] = res[i].name;
              // 如果没有开始时间和审批人
              if (!res[i].startTime && !res[i].assignee) {
                data['wf_comment_' + res[i].taskDefKey] = '未审批';
                data['wf_comment_' + res[i].name] = '未审批';
              }
            }
            let params = {
              parentIds: sings
            };
            // debugger
            getFlowImgs(params).then(res1 => {
              // debugger
              for (let i = 0; i < res.length; i++) {
                let image = {'Image': ''};
                if (res1) {
                  for (const key in res1) {
                    if (res[i].sign == key) {
                      image.Image = res1[key];
                      data['wf_sign_' + res[i].taskDefKey] = res1[key];
                      data['wf_sign_' + res[i].name] = res1[key];
                      data[res[i].name + 'sign'] = res1[key];
                    }
                  }
                }
                imageList.push(image);

                for (const key in res1) {
                  _this.signData[key] = res1[key];
                }
              }
              _this.ImageList = imageList;
              // console.log('-------_this.ImageList--------',_this.ImageList)
            });
          }
          _this.flowList = flowList;
          _this.flowData = data;
          // console.log('-----------',_this.signData,_this.wfData,_this.flowList, _this.flowData,_this.ImageList)
        });
      }
    },
    treeToArray (data) {
      let tmp = [];
      if (data) {
        data.forEach(record => {
          tmp.push(record);
          if (record.children && record.children.length > 0) {
            let children = this.treeToArray(record.children);
            tmp = tmp.concat(children);
          }
        });
      }
      return tmp;
    },
    subDicValue (column, value) { // 数据字典label
      // console.info(column)
      // console.info(JSON.stringify(column))
      if (column && column.options) {
        // console.info('---dicMap[column.columnName]---'+JSON.stringify(this.dicMap[column.columnName]))
        // console.info(value+'-------'+this.dicMap[column.columnName][value+''])
        if (column.multiple === 1 && value) {
          if (typeof value === 'string') {
            value = value.split(',');
          }
          let str = '';
          value.forEach(item => {
            let e = column.options.find(item => {
              return item.value === value;
            });
            str = e ? str += e.name + ',' : str;
          });
          if (str) {
            value = str.slice(0, str.length - 1);
          }
        } else {
          let e = column.options.find(item => {
            return item.value === value;
          });
          value = e ? e.name : value;
        }
      }
      return value || '';
    },
    // 过滤子表数据
    filterSubData (data, config) {
      if (!data || !config) return;
      // 如果是树表 需将数据扁平化
      if (config.isTree) {
        data = this.treeToArray(data);
      }
      data.forEach(item => {
        let columns = config.queryColumns;
        // 拿到原来的config
        let table = this.$refs['sub-form-' + config.tableName] ? this.$refs['sub-form-' + config.tableName][0] : null;
        if (table) {
          columns = table.columns;
        }
        columns.forEach(e => {
          if (e && (e.widgetType === 'select-form' ||
              e.widgetType === 'select-user' ||
              e.widgetType === 'select-depart' ||
              e.widgetType === 'select-date' ||
              e.widgetType === 'select-role' ||
              e.widgetType === 'select-time' ||
              e.widgetType === 'select-date-time' ||
              e.columnName === 'CREATE_USER_')
          ) {
            if (item[e.columnName + 'LABEL_']) {
              item[e.columnName] = item[e.columnName + 'LABEL_'];
              delete data[e.columnName + 'LABEL_'];
            }
          }
          if (e && (e.widgetType === 'select-dic' ||
              e.widgetType === 'select-sql' ||
              e.widgetType === 'select' ||
              e.widgetType === 'select-api')
          ) {
            if (e.options) {
              item[e.columnName] = this.subDicValue(e, item[e.columnName]);
            } else if (item[e.columnName + 'LABEL_']) {
              item[e.columnName] = item[e.columnName + 'LABEL_'];
              delete data[e.columnName + 'LABEL_'];
            }
          }
          // 如果是switch控件 判断是否选中 默认1为是 0 为否
          if (e.widgetType === 'switch') {
            let activeValue = (e.options && e.options[1] !== undefined) ? e.options[1] : '是';
            let inActiveValue = (e.options && e.options[0] !== undefined) ? e.options[0] : '否';
            item[e.columnName] = (item[e.columnName + '_SWITCH'] == 'true') ? activeValue : inActiveValue;
          } else if (e.widgetType === 'file') {
            // console.log('----item------',item);
          }
        });
      });
      if (config.isTree) {
        // 去掉父子级关系
        data = data.map(item => {
          delete item.children;
          return item;
        });
      } else {
        data = data.map(item => {
          delete item.subFormConfig;
          return item;
        });
      }
      return data;
    },
    selected (item, list) {
      // 由于单选
      for (var i = 0; i < list.length; i++) {
        // 默认第一个选中
        var temp = list[i];
        // console.info(temp.id +'=='+ item.id)
        if (temp.id == item.id) {
          temp.selected = true;
        } else {
          temp.selected = false;
        }
      }
      this.$forceUpdate();
    },
    checkFieldValidType (rule) {
      let validType = rule.validType;
      let val = this.mainData[rule.column.columnName];
      if (validType && rule.column.columnName && val) {
        // 判断是否是小数
        if (validType == 'float') {
          return (!(!val || isNaN(val))) && String(val).indexOf('.') > -1;
        } else if (validType == 'number') {
          return !(!val || isNaN(val));
        } else if (validType == 'phone') {
          return this.validUtil.isMobile(val);
        } else if (validType == 'email') {
          return this.validUtil.isEmail(val);
        }
      }
      return true;
    },
    checkFieldValid (column) { // 验证主表列的合法性
      if (column.validRule) {
        let validRule = column.validRule;
        console.log('--------validRule--v1----->'+validRule);
        // 判断是否正则
        let isRegExp = true;
        for (let j = 0; j < this.formColumns.length; j++) {
          const edit = this.formColumns[j];
          if (edit.columnName !== '' && validRule.indexOf(edit.columnName) > -1) {
            isRegExp = false;
            let value = this.mainData[edit.columnName];
            console.log(edit.columnName+"<==value=====>",value);
            if (this.validUtil.isNull(value)) {
              if (edit.javaType === 'Double' || edit.javaType === 'Integer') {
                value = 0;
              }else if(edit.javaType === 'String'){
                value=`'${value}'`
              } else {
                value = '';
              }
            } else {
              if (edit.javaType === 'Double' || edit.javaType === 'Integer') {
                value = parseFloat(value);
              }else if(edit.javaType === 'String'){
                value=`'${value}'`
              } else {
                value = '';
              }
            }
            validRule = validRule.replace(new RegExp('{' + edit.columnName + '}', 'gm'), value);
          }
        }
        // console.log(isRegExp+'====='+column.columnName+'====isRegExp======'+column.validRule,this.mainData[column.columnName]);
        if(isRegExp){
          //let value = this.getValByColumnName(column.columnName);
          let value = this.mainData[column.columnName];
          var regExp = undefined;
          eval('regExp='+column.validRule);
          // let re = new RegExp(/^[0-9]{1,10}$/);
          let re = new RegExp(eval(column.validRule));
          // console.log(value+'--------------',column.validRule,re,re.test(value));
          if (!re.test(value)) {
            return false;
          }
          // console.log('--------validRule-------'+validRule);
        }else{
          console.log('--------validRule--v2----->'+validRule);
          if (!eval(validRule)) {
            console.log("验证失败哦，哈哈");
            return false;
          }else{
            console.log("验证成功！，哈哈");
          }
        }

      }
      return true;
    },
    validateField (rule, value, callback) { // 自定义验证字段
      if (rule.required) {
        // console.log('------validateField-----',rule, value,this.mainData)
        // console.info(rule)
        if (rule.column.widgetType === 'file') {
          let uploading = this.$refs['uploading_' + rule.column.columnName];
          if (uploading) {
            if (uploading.length > 0) {
              uploading = uploading[0];
            }
            // console.info(uploading.filesList)
            let fileList = uploading.getFilesArr();
            if (fileList.length === 0) {
              return callback(new Error(rule.message));
            }
          }
        } else {
          if (rule.column.widgetType === 'checkbox') {
            // 如果是多选
            let options = this.mainData[rule.column.columnName + 'LABEL_'];
            let str = '';
            if (options && options.length > 0) {
              for (let i = 0; i < options.length; i++) {
                if (i != 0) {
                  str += ',';
                }
                str += options[i];
              }
            }
            this.mainData[rule.column.columnName] = str;
            value = str;
          }

          if (rule.type === 'number') {
            if (rule.column.widgetType && (rule.column.widgetType === 'select' || rule.column.widgetType === 'select-sql' || rule.column.widgetType === 'select-dic')) {
              if (value === undefined) {
                return callback(new Error(rule.message));
              }
            } else {
              if (!value || value === '0' || value === 0) {
                return callback(new Error(rule.message));
              }
            }
          } else {
            if (!value) {
              return callback(new Error(rule.message));
            }
          }
        }
      }
      // console.log('------111------')
      if (!this.checkFieldValidType(rule)) {
        rule.message = rule.column.validMessage;
        return callback(new Error(rule.column.validMessage));
        // console.info('-----validateField----')
      }
      // console.log('------222------')
      if (!this.checkFieldValid(rule.column)) {
        rule.message = rule.column.validMessage;
        // console.log('---------',rule.column.validMessage)
        return callback(new Error(rule.column.validMessage));
      }
      callback();
    },
    submitData () { // 最终提交
      // eslint-disable-next-line no-unused-vars
      let _this = this;
      // console.info('----1----')
      var params = this.getData();

      // console.info('----2----')
      // 调用api
      saveData(params).then(res => {
        // 判断是否消息打开，关闭
        if (this.$route && this.$route.query && this.$route.query._isOpenPage) {
          this.$bus.emit('app-main-on-tab-close', this.$route.path);
          return;
        }
        // console.info(this.$refs)
        // console.info('----3----')
        // return
        // 判断是否刷新父页面
        if (_this.defaultConfig.parent && _this.defaultConfig.parent.closeForm) {
          _this.defaultConfig.parent.closeForm();
          // setTimeout(function(){
          //   // _this.defaultConfig.parent.closeForm()
          // },5000);
        }
        let flag = false;
        if (_this.defaultConfig.events) {
          _this.defaultConfig.events.forEach(event => {
            if (event.type == '11') {
              flag = true;
            }
          });
        }
        if (_this.defaultConfig.parent && flag) {
          _this.defaultConfig.parent.loadParentData();
        }
        if (_this.config.parent && _this.defaultConfig.parent.handlerSaveDataCallback) {
          _this.defaultConfig.parent.handlerSaveDataCallback(this.validUtil.isNull(params.businessKey) ? 'new' : 'edit', params, res.id);
        } else {
          if (_this.config.parent && _this.defaultConfig.parent.loadData) {
            // 如果父页面是树 者触发行change事件
            if (_this.defaultConfig.parent) {
              _this.defaultConfig.parent.handlerTreeChangeValue(this.mainData);
            }
            setTimeout(() => {
              _this.defaultConfig.parent.loadData(null, false);
            }, 500);
          }
        }
        // 如果是弹框 则调用父页面刷新方法
        if (_this.openConfig && _this.openConfig.parent && _this.openConfig.parent.loadData && _this.openConfig.parent.openDialogVueName === 'form-edit') {
          _this.openConfig.parent.loadData(null, false);
        }
        _this.util.success('成功');
      });
    },
    saveDataCallback (type, params) { // 流程控件保存回调
      // 删除缓存
      this.cookieUtil.set(this.$route.path, null);
      // 判断是否消息打开，关闭
      if (this.$route && this.$route.query && this.$route.query._isOpenPage) {
        this.$bus.emit('app-main-on-tab-close', this.$route.path);
        return;
      }
      // console.log('------------saveDataCallback--------------' + type)
      // 反核销、办理，驳回，撤销
      if (type === -2 || type === 6 || type === 5 || type === 3) {
        // 判断是否直接打开表单
        if (this.$route.path && this.$route.path.indexOf('/form/edit/') > -1) {
          this.$router.go(-1);
        }
        if (type === 3) { // 撤销
          this.$bus.$emit('handlerApplyReload', params);
        } else {
          this.$bus.$emit('handlerApprovalReload', params);
          this.$bus.$emit('handlerCopyReload', params);
        }
      }
      if (type === 8) {
        if (this.config.parent === undefined) {
          // 判断是否直接打开表单
          if (this.$route.path && this.$route.path.indexOf('/form/edit/') > -1) {
            this.$router.go(-1);
          }
          this.$bus.$emit('handlerApplyReload', params);
        }
      }

      // console.log('-------this.config.parent------',this.config,this.defaultConfig.parent,this.defaultConfig.parent.loadData)
      if (this.defaultConfig.parent && this.defaultConfig.parent.loadData) {
        this.defaultConfig.parent.loadData(null, false);
        if (type !== -2) { this.submit(type); }
      }
    },
    // 选人点击事件
    selectMember (column) {
      if (!this.formColumnReadOnly(column)) {
        if (column.widgetType === 'select-project-member') {
          this.selectProjMemberModels.isShow = true;
          this.selectProjMemberModels.projId = this.mainData[column.attr];
          this.selectProjMemberModels.form = column;
          this.selectProjMemberModels.selectList = (typeof this.mainData[column.columnName] === 'object') ? this.mainData[column.columnName] : [];
          this.selectProjMemberModels.radioSelectFlags = (column.widgetType === 'select-project');
        } else if (column.widgetType === 'select-user-multi') {
          this.selectMemberModels.isShow = true;
          this.selectMemberModels.form = column;
          let ids = this.mainData[column.columnName];
          let labels = this.mainData[column.columnName + 'LABEL_'];
          let selectList = [];
          if (this.validUtil.isNotNull(ids)) {
            let idArr = ids.split(',');
            let labelArr = labels.split(',');
            idArr.forEach((id, index) => {
              selectList.push({
                id: id,
                userName: labelArr[index]
              });
            });
          }
          this.selectMemberModels.selectList = selectList;
          this.selectMemberModels.radioSelectFlags = (column.widgetType === 'select-user');
        } else {
          // console.info('========selectMember======')
          this.selectMemberModels.isShow = true;
          this.selectMemberModels.form = column;
          let selectList = [];
          if(typeof this.mainData[column.columnName] === 'object'){
            selectList = this.mainData[column.columnName];
          }else{
            let id = this.mainData[column.columnName];
            let label = this.mainData[column.columnName + 'LABEL_'];
            if(id && label){
              // 如果不关联
              if (column.ifNotRelated == 1) {

              }else{
                selectList.push({
                  id: id,
                  userName: label
                });
              }
            }
          }
          this.selectMemberModels.selectList = selectList;
          this.selectMemberModels.radioSelectFlags = (column.widgetType === 'select-user');
        }
      }
    },
    removeProcUser (user, column) {
      this.mainData[column.columnName] = this.mainData[column.columnName].filter(
        item => {
          return item != user;
        }
      );
      this.userList[column.columnName] = this.userList[column.columnName].filter(
        item => {
          return item != user;
        }
      );
      if(this.mainData[column.columnName].length == 0){
        this.userList = [];
        delete this.mainData[column.columnName]
      }

    },
    initApiConfig (column) { // 表单初始化遍历字段，统计api接口触发
      if (column.apiConfig) {
        let _this = this;
        let apiConfig = column.apiConfig;
        if (apiConfig[0] && apiConfig[0].children) {
          apiConfig[0].children.forEach(item => {
            // 判断是否需要表单传参
            if (item.value && item.value.indexOf('{') > -1) {
              let value = item.value.trim();
              let columnName = value.substring(value.indexOf('{') + 1, value.indexOf('}'));
              // console.info(columnName)
              let apiSourceData = _this.apiSourceData[columnName];
              if (apiSourceData == undefined) {
                apiSourceData = [];
                _this.apiSourceData[columnName] = apiSourceData;
              }
              apiSourceData.push(apiConfig[0]);
            }
          });
        }
      }
      // console.info(this.apiSourceData)
    },
    initShowConditionConfig (column) { // 初始化字段隐藏条件
      let condition = column.showCondition;
      let _this = this;

      // 先判断企业私有常量
      let keys = condition.match(/\{org-conf-(.*?)\}/gi); // 匹配所有类似{org-conf-ims.wf.sporadic.index}的变量
      if (keys) {
        keys.forEach(key => {
          let columnName = key.trim().substring(key.indexOf('{') + 1, key.indexOf('}'));
          // console.log('-------columnName------',columnName)
          let value = this.sessionUtil.getOrgConfByKey(columnName);
          if (this.validUtil.isNotNull(value)) {
            condition = condition.replace(key, value);
          }
        });
      }
      // console.log('------condition------',condition)
      keys = condition.match(/\[(.*?)\]/gi); // 匹配所有类似[项目名称]的变量
      if (keys) {
        keys.forEach(key => {
          let columnName = key.trim().substring(key.indexOf('[') + 1, key.indexOf(']'));
          // console.info(columnName)
          // 先判断是否是表单字段
          let colName = _this.formColumnTitleMap[columnName];
          let col = _this.formColumnsMap[colName];

          if (col !== undefined && col !== null) {
            if (col.showConditionData === undefined) {
              col.showConditionData = {};
            }
            col.showConditionData[column.columnName] = {
              rule: condition,
              keys: keys
            };
            this.showConditionColumns.push(col);
          } else {
            // 也许是系统常量

          }
        });
      } else {
        // 说明已经全部过滤完了
        try {
          // 默认显示
          let flag = false;
          let rule = 'flag = (' + condition + ')';
          eval(rule);
          // alert(("银行转帐" !== "银行转账"))
          // console.log('----------计算隐藏显示---------'+flag,rule)
          if (flag) {
            // 设置隐藏
            this.showConditionData[column.columnName] = true;
          } else {
            this.showConditionData[column.columnName] = false;
          }
          this.$forceUpdate();
        } catch (e) {
          console.log('----------计算隐藏显示----error-----', rule, e);
        }
      }
    },
    computeShowConditionConfig (c) { // 计算显示隐藏规则
      let columns = [];
      if (c) {
        if (!c.showConditionData) {
          return;
        }
        columns.push(c);
      } else {
        this.showConditionColumns.forEach(item => {
          if (item.showConditionData) {
            // console.log('-------item.showConditionData-----',item.title,item)
            columns.push(item);
          }
        });
      }
      // console.log('------computeShowConditionConfig------',columns,this.showConditionColumns,this.formColumns);
      columns.forEach(column => {
        // 计算隐藏显示
        if (column.showConditionData) {
          for (let desColumnName in column.showConditionData) {
            let ruleConfig = column.showConditionData[desColumnName];
            let rule = ruleConfig.rule + '';
            let keys = ruleConfig.keys;
            keys.forEach(key => {
              let srcColumnTitle = key.trim().substring(key.indexOf('[') + 1, key.indexOf(']'));
              let val = this.getValByColumnTitle(srcColumnTitle);
              rule = rule.replace(key, val);
            });
            try {
              // 默认显示
              let flag = false;
              rule = 'flag = (' + rule + ')';
              eval(rule);
              // alert(("银行转帐" !== "银行转账"))
              //console.log(this.mainData[column.columnName]+'----------计算隐藏显示---------'+flag,rule,this.mainData);
              if (flag) {
                // 设置隐藏
                this.showConditionData[desColumnName] = true;
              } else {
                this.showConditionData[desColumnName] = false;
              }
              this.$forceUpdate();
            } catch (e) {
              // console.log('----------计算隐藏显示----error-----',rule,e)
            }
          }
        }
      });
    },
    initRuleComputeConfig (columns, column, mainData) { // 字段初始化所有拼接的方法
      let rule = column.sourceAttr;
      let _this = this;
      // console.info(this.defaultConfig)
      // this.ruleComputeData[column.columnName] = rule
      // return
      // console.info(rule)
      // console.log('----initRuleComputeConfig----',column.title,column)
      let keys = rule.match(/\[(.*?)\]/gi); // 匹配所有类似[项目名称]的变量
      if (keys) {
        keys.forEach(key => {
          let columnName = key.trim().substring(key.indexOf('[') + 1, key.indexOf(']'));
          // console.info(columnName)
          // 先判断是否是表单字段
          let colName = _this.formColumnTitleMap[columnName];
          let col = _this.formColumnsMap[colName];

          if (col !== undefined && col !== null) {
            if (_this.ruleComputeData[col.columnName] === undefined) {
              _this.ruleComputeData[col.columnName] = [];
            }
            _this.ruleComputeData[col.columnName].push({
              rule: rule,
              keys: keys,
              desColumnName: column.columnName
            });
          } else {
            if (_this.ruleComputeData[columnName] === undefined) {
              _this.ruleComputeData[columnName] = [];
            }
            _this.ruleComputeData[columnName].push({
              rule: rule,
              keys: keys,
              desColumnName: column.columnName
            });
          }
        });
      }
      // console.log('----initRuleComputeConfig----',_this.ruleComputeData)
      // console.info( _this.ruleComputeData)
    },
    computeRuleComputeConfig (columnName) {
      // 计算数据来源为规则计算的表单
      // console.info('-------computeRuleComputeConfig------' + columnName, this.ruleComputeData, this.ifFormEditRender)
      // console.log(this.mainData)
      // return
      let _this = this;
      let ruleComputeData = null;
      // 设置默认是初始化触发
      let isInit = true;
      if (columnName !== undefined) {
        let temp = this.ruleComputeData[columnName];
        if (temp) {
          // 说明是单字段触发
          isInit = false;
          ruleComputeData = {};
          ruleComputeData[columnName] = this.ruleComputeData[columnName];
        } else {
          return;
        }
      } else {
        // 说明是初始化新增的时候全部算一次
        ruleComputeData = this.ruleComputeData;
      }
      // console.log('-----ruleComputeData----',this.mainData,ruleComputeData,JSON.stringify(this.mainData))
      // console.info(ruleComputeData)
      // return
      if (ruleComputeData != null) {
        // return
        for (let key in ruleComputeData) {
          let ruleConfigArr = ruleComputeData[key];
          for (let m = 0; m < ruleConfigArr.length; m++) {
            var ruleConfig = ruleConfigArr[m];
            let desColumnName = ruleConfig['desColumnName'];

            // 如果是loadData之后调用，且该字段有值，则说明可能是编辑状态，编辑的时候不再进行计算
            if (isInit && this.validUtil.isNotNull(this.mainData[desColumnName])) {
              continue;
            }

            // console.log('------1111-------',desColumnName,ruleConfig)

            var value = ruleConfig.rule + '';
            let keys = ruleConfig.keys;
            keys.forEach(key => {
              let srcColumnTitle = key.trim().substring(key.indexOf('[') + 1, key.indexOf(']'));
              let val = this.getValByColumnTitle(srcColumnTitle);
              // console.log('------computeRuleComputeConfig-----',JSON.stringify(this.mainData['MONTH_']))
              value = value.replace(key, val);
              // console.log(srcColumnTitle+'-------------'+val,value)
            });

            // 判断是否有变量{}
            if (value.indexOf('{') > -1 && value.indexOf('}') > -1) {
              if (this.defaultConfig && this.defaultConfig.initValues) {
                let initValues = this.defaultConfig.initValues;
                // console.info(initValues)
                if (initValues) {
                  for (let key in initValues) {
                    value = value.replace('{' + key + '}', initValues[key]);
                  }
                }
              }
            }
            // console.info(desColumnName+'---value---'+('value = ' + value))
            // 判断是否日期计算
            if (value.indexOf('addDays') > -1) {
              // 兼容新的做法，dateUtil中也含有addDays方法
              if (value.indexOf('dateUtil.addDays') > -1) {

              }else{
                value = value.replace('addDays', '_this.util.addDays');
              }
              // console.log('--------进入--------')
             }
            if (value.indexOf('dateUtil.') > -1) {
              value = value.replace('dateUtil.', '_this.dateUtil.');
            }
            if (value.indexOf('mathUtil.') > -1) {
              value = value.replace('mathUtil.', '_this.mathUtil.');
            }
            for (let funType in FUN_DATA) {
              // console.log(funType + '-----' + expressionStr.indexOf(funType + '.'))
              if (value.indexOf(funType + '.') > -1) {
                value = funUtil.replaceStr(funType, value);
              }
            }
            // console.log('------value------',value);
            try {
              eval('value = ' + value);
              // value = this.toFixed(value)
              // console.info(typeof value)
              let desColumn = _this.formColumnsMap[desColumnName];
              // 如果不是编辑时第一次渲染，或者编辑时第一次渲染，但是时静默类型，则就每次都计算
              if (!this.ifFormEditRender || (this.ifFormEditRender && desColumn && desColumn.silence && desColumn === 1)) {
                if (value === 'NaN') {
                  _this.mainData[desColumnName] = 0;
                } else {
                  _this.mainData[desColumnName] = value;
                  if (typeof _this.mainData[desColumnName] !== 'string') {
                    _this.mainData[desColumnName] = this.toFixed(value);
                  }
                }
              }
              this._handlerValueChange(desColumn, _this.mainData[desColumnName]);
            } catch (e) {

            }
          }
          // console.info(desColumnName+'---value---'+value)
        }
      }
    },
    getValByColumnName (srcColumnName) {
      let _this = this;
      let srcColumn = _this.formColumnsMap[srcColumnName];
      let val = null;
      if (srcColumn && srcColumnName) {
        // 说明是数据库字段
        if (srcColumn.widgetType === 'select-form' || srcColumn.widgetType === 'select-user' || srcColumn.widgetType === 'select-depart') {
          val = '"' + _this.mainData[srcColumnName + 'LABEL_'] + '"';
          // console.info('---val----'+val)
        } else if (srcColumn.widgetType === 'select' || srcColumn.widgetType === 'select-dic' || srcColumn.widgetType === 'select-sql') {
          let options = srcColumn.options;
          // console.info(srcColumnTitle+'-----getValByColumnTitle--1--'+options)
          if (options) {
            let option = options.find(option => {
              return option.value === _this.mainData[srcColumnName];
            });
            if (option) {
              val = '"' + option.value + '"';
            }
          }
        } else if (srcColumn.widgetType === 'select-date' || srcColumn.widgetType === 'select-time' || srcColumn.widgetType === 'select-date-time') {
          val = '"' + _this.mainData[srcColumnName] + '"';
        }else if (srcColumn.widgetType === 'radio') {
          val = _this.mainData[srcColumnName + 'LABEL_'];
          if (srcColumn.javaType === 'Integer' || srcColumn.javaType === 'Double' || srcColumn.javaType === 'Float') {
            val = val;
          } else {
            val = '"'+val+'"';
          }
        } else {
          // console.log('----------22-----------',srcColumnName,srcColumn)
          if (srcColumn.javaType === 'String') {
            val = '"' + _this.mainData[srcColumnName] + '"';
          } else {
            val = _this.mainData[srcColumnName];
          }
        }
        // console.info(srcColumnTitle+'----'+srcColumn.javaType+'-----'+val)
        if (val == 'undefined' || val == '"undefined"' || val === undefined || val === null || val === '') {
          if (srcColumn.javaType === 'Integer' || srcColumn.javaType === 'Double' || srcColumn.javaType === 'Float') {
            val = 0;
          } else {
            val = '""';
          }
        }
      }
      // console.info(srcColumnTitle+'---22222-----'+val)
      // console.info(key+'--'+(val == '"undefined"')+'--'+typeof val+'--'+val)
      // console.info(val.length+'--'+'undefined'.length)
      if (val == 'undefined' || val == '"undefined"' || val === undefined || val === null) {
        val = '""';
      }
      return val;
    },
    getValByColumnTitle (srcColumnTitle) { // 根据字段名称获取val
      let _this = this;
      let srcColumnName = _this.formColumnTitleMap[srcColumnTitle];
      // let srcColumn = _this.formColumnsMap[srcColumnName];
      // console.info(srcColumnTitle+'-----getValByColumnTitle----'+srcColumnName)
      let val = null;
      if(srcColumnName){
        val =  this.getValByColumnName(srcColumnName);
      }else {
        // 判断是否系统常量
        val = '"' + this.getConstValue(srcColumnTitle) + '"';
      }
      return val;
    },
    toFixed (num) {
      let m;
      try {
        m = num.toString().split('.')[1].length;
      } catch (e) {
        m = 0;
      }
      var times = Math.pow(10, m);
      var des = 0;
      if (num > 0) {
        des = num * times + 0.5;
      } else {
        des = num * times - 0.5;
      }
      des = parseInt(des, 10) / times;
      return des + '';
    },
    registerSubFormChangeEvent (column) { // 明细表注册事件，主表字段切换修改明细表
      if (column.config && column.config.events) {
        let events = column.config.events;
        let _this = this;
        events.forEach(event => {
          // console.log(event,parseInt(event.type))
          if (parseInt(event.type) === EVENT_TYPE.SUB_FORM_CHANGE_BY_MAIN_FORM) {
            // console.info('------1-----')
            if (event.apiConfig) {
              let apiConfig = event.apiConfig;
              // console.info('-----------' + apiConfig.id)
              if (apiConfig.children) {
                // console.info('------22-----')
                apiConfig.children.forEach(item => {
                  // 判断是否需要表单传参
                  if (item.value && item.value.indexOf('{') > -1) {
                    let value = item.value.trim();
                    let columnName = value.substring(value.indexOf('{') + 1, value.indexOf('}'));
                    // console.info(columnName)
                    let apiSourceData = _this.apiSourceData[columnName];
                    if (apiSourceData == undefined) {
                      apiSourceData = [];
                      _this.apiSourceData[columnName] = apiSourceData;
                    }
                    apiConfig.eventType = EVENT_TYPE.SUB_FORM_CHANGE_BY_MAIN_FORM;
                    apiConfig.subFormKey = column.columnName;
                    apiSourceData.push(apiConfig);
                  }
                });
              }
              // console.info('--registerSubFormChangeEvent--',_this.apiSourceData)
            }
          }
        });
      }
    },
    projMemberCallBack () {
      this.selectProjMemberModels.isShow = false;
      var vm = this;
      this.formRows.forEach(element => {
        element.forEach(e => {
          if (e.columnName === this.selectProjMemberModels.form.columnName) {
            var value = [];
            // console.log('---------attr-------'+attr)
            this.selectProjMemberModels.selectList.forEach(item => {
              let user = {
                USER_NAME_: item.userName,
                userName: item.userName,
                USER_UID_: item.id,
                PICTURE_: item.picture,
                picture: item.picture
              };
              value.push(user);
            });
            vm.$set(vm.userList, e.columnName, value);
            vm.$set(vm.mainData, e.columnName, value);
          }
        });
      });
    },
    // 选人回调函数
    memberCallBack () {
      this.selectMemberModels.isShow = false;
      var vm = this;
      let e = this.selectMemberModels.form;
      if (this.selectMemberModels.form.widgetType === 'select-user') {
        if (this.selectMemberModels.selectList.length > 0) {
          vm.$set(vm.mainData, e.columnName + 'LABEL_', this.selectMemberModels.selectList[0].userName);
          vm.$set(vm.mainData, e.columnName, this.selectMemberModels.selectList[0].id);
          // 如果不关联
          if (this.selectMemberModels.form.ifNotRelated == 1) {
            if (e.columnName.lastIndexOf('UID_') > -1 || e.columnName.lastIndexOf('ID_') > -1) {
              vm.$set(vm.mainData, e.columnName, this.selectMemberModels.selectList[0].id);
              vm.$set(vm.mainData, e.columnName + 'LABEL_', this.selectMemberModels.selectList[0].id);
            }
            if (e.columnName.lastIndexOf('NAME_') > -1) {
              vm.$set(vm.mainData, e.columnName, this.selectMemberModels.selectList[0].userName);
              vm.$set(vm.mainData, e.columnName + 'LABEL_', this.selectMemberModels.selectList[0].userName);
            }
          }
          // 判断字段是否为ID_或UID_结尾 是则给NAME_也赋值
          if (e.columnName.lastIndexOf('UID_') > -1) {
            let name = e.columnName.split('UID_');
            vm.$set(vm.mainData, name[0] + 'NAME_', this.selectMemberModels.selectList[0].userName);
          }
          if (e.columnName.lastIndexOf('ID_') > -1) {
            let name = e.columnName.split('ID_');
            vm.$set(vm.mainData, name[0] + 'NAME_', this.selectMemberModels.selectList[0].userName);
          }
          // 如果是NAME_结尾 给ID_和UID_也赋值
          if (e.columnName.lastIndexOf('NAME_') > -1) {
            let name = e.columnName.split('NAME_');
            vm.$set(vm.mainData, e.columnName, this.selectMemberModels.selectList[0].userName);
            vm.$set(vm.mainData, name[0] + 'ID_', this.selectMemberModels.selectList[0].id);
            vm.$set(vm.mainData, name[0] + 'UID_', this.selectMemberModels.selectList[0].id);
          }

          // 因选人组件中无法触发change时间，则手动触发_handlerValueChange
          vm._handlerValueChange(e, vm.mainData[e.columnName]);
        }else{
          vm.handleClear(e);
        }
      } else if (this.selectMemberModels.form.widgetType === 'select-user-multi') {
        // eslint-disable-next-line no-unused-vars
        var labels = '';
        var ids = '';
        this.selectMemberModels.selectList.forEach(element => {
          labels += element.userName + ',';
          ids += element.id + ',';
        });
        labels = labels.substring(0, labels.length - 1);
        ids = ids.substring(0, ids.length - 1);
        vm.$set(vm.mainData, e.columnName + 'LABEL_', labels);
        vm.$set(vm.mainData, e.columnName, ids);

        // 如果不关联
        if (this.selectMemberModels.form.ifNotRelated == 1) {
          if (e.columnName.lastIndexOf('UID_') > -1 || e.columnName.lastIndexOf('ID_') > -1) {
            vm.$set(vm.mainData, e.columnName, ids);
            vm.$set(vm.mainData, e.columnName + 'LABEL_', ids);
          }
          if (e.columnName.lastIndexOf('NAME_') > -1) {
            vm.$set(vm.mainData, e.columnName, labels);
            vm.$set(vm.mainData, e.columnName + 'LABEL_', labels);
          }
        }
        // 判断字段是否为ID_或UID_结尾 是则给NAME_也赋值
        if (e.columnName.lastIndexOf('UID_') > -1) {
          let name = e.columnName.split('UID_');
          vm.$set(vm.mainData, name[0] + 'NAME_', labels);
        }
        if (e.columnName.lastIndexOf('ID_') > -1) {
          let name = e.columnName.split('ID_');
          vm.$set(vm.mainData, name[0] + 'NAME_', labels);
        }
        // 如果是NAME_结尾 给ID_和UID_也赋值
        if (e.columnName.lastIndexOf('NAME_') > -1) {
          let name = e.columnName.split('NAME_');
          vm.$set(vm.mainData, e.columnName, labels);
          vm.$set(vm.mainData, name[0] + 'ID_', ids);
          vm.$set(vm.mainData, name[0] + 'UID_', ids);
        }
      } else if (this.selectMemberModels.form.widgetType === 'select-user-list') {
        var value = [];
        let attr = this.selectMemberModels.form.attr;
        // console.log('---------attr-------'+attr)
        this.selectMemberModels.selectList.forEach(item => {
          if (this.validUtil.isNotNull(attr)) {
            item.USER_NAME_ = item.userName;
            item.USER_UID_ = item.id;
            item.PICTURE_ = item.picture;
            let rule;

            try {
              let attrObj = JSON.parse(attr);
              if (attrObj && attrObj['rule']) {
                rule = attrObj['rule'];
              }
            } catch (e) {
              console.log('-------memberCallBack---多选人回调解析控件参数报错----', e);
            }

            if (rule) {
              for (let columnName in rule) {
                let key = rule[columnName];
                // 判断key是否常量
                if (key != undefined && String(key).indexOf('{') === -1 && this.validUtil.isNull(item[key])) {
                  item[columnName] = key;
                } else {
                  item[columnName] = item[key];
                }
              }
            }
            // 说明是直接写死类型 接的写法
            /* let options = attr.split(';')
            options.forEach(item => {
              let option = item.split(',')
              // 存入键值对
              if (item[option[1]]) {
                item[option[0]] = item[option[1]]
              }
            }) */
          } else {
            item.USER_NAME_ = item.userName;
            item.USER_UID_ = item.id;
            item.PICTURE_ = item.picture;
          }
          value.push(item);
        });
        vm.$set(vm.userList, e.columnName, value);
        vm.$set(vm.mainData, e.columnName, value);
      }
      vm._handlerValueChange(e, vm.mainData[e.columnName]);
      vm.$refs['mainForm'].validateField([e.columnName], (error) => {
        console.log('--validateField-error---', error);
      });
    },
    closeProcessForm () { // 关闭流程处理
      this.processFormVisible = !this.processFormVisible;
    },
    // 选角色点击事件
    selectRole (column, row, index) {
      if (!this.formColumnReadOnly(column)) {
        this.selectRoleModels.isShow = true;
        this.selectRoleModels.form = column;
        this.selectRoleModels.selectList = this.mainData[column.columnName] || [];
        this.selectRoleModels.radioSelectFlags = (column.widgetType === 'select-role');
      }
    },
    // 选角色回调函数
    selectRoleCallBack () {
      let vm = this;
      if (this.selectRoleModels.selectList.length == 0) {
        this.util.warn('请至少选择一个角色！');
        return false;
      }
      this.selectRoleModels.isShow = false;
      this.formRows.forEach(element => {
        element.forEach(e => {
          if (e.columnName === this.selectRoleModels.form.columnName) {
            if (this.selectRoleModels.form.widgetType === 'select-role') {
              vm.$set(vm.mainData, e.columnName + 'LABEL_', this.selectRoleModels.selectList[0].roleName);
              vm.$set(vm.mainData, e.columnName, this.selectRoleModels.selectList[0].id);
              if (e.columnName.lastIndexOf('UID_') > -1) {
                let name = e.columnName.split('UID_');
                vm.$set(vm.mainData, name[0] + 'NAME_', this.selectRoleModels.selectList[0].roleName);
              }
              if (e.columnName.lastIndexOf('ID_') > -1) {
                let name = e.columnName.split('ID_');
                vm.$set(vm.mainData, name[0] + 'NAME_', this.selectRoleModels.selectList[0].roleName);
              }
            } else if (this.selectRoleModels.form.widgetType === 'select-role-multi') {
              // eslint-disable-next-line no-unused-vars
              var labels = '';
              var ids = '';
              this.selectRoleModels.selectList.forEach(element => {
                labels += element.roleName + ',';
                ids += element.id + ',';
              });
              vm.$set(vm.mainData, e.columnName + 'LABEL_', labels.substring(0, labels.length - 1));
              vm.$set(vm.mainData, e.columnName, ids.substring(0, ids.length - 1));

              if (e.columnName.lastIndexOf('UID_') > -1) {
                let name = e.columnName.split('UID_');
                vm.$set(vm.mainData, name[0] + 'NAME_', labels.substring(0, labels.length - 1));
              }
              if (e.columnName.lastIndexOf('ID_') > -1) {
                let name = e.columnName.split('ID_');
                vm.$set(vm.mainData, name[0] + 'NAME_', labels.substring(0, labels.length - 1));
              }
            } else if (this.selectRoleModels.form.widgetType === 'select-role-list') {
              var value = [];
              let attr = this.selectRoleModels.form.attr;
              this.selectRoleModels.selectList.forEach(item => {
                if (attr && attr.indexOf(',') > -1) {
                  // 说明是直接写死类型
                  let options = attr.split(';');
                  options.forEach(item => {
                    let option = item.split(',');
                    // 存入键值对
                    if (item[option[1]]) {
                      item[option[0]] = item[option[1]];
                    }
                  });
                } else {
                  item.ROLE_NAME_ = item.roleName;
                  item.ROLE_UID_ = item.id;
                }
                value.push(item);
              });
              vm.$set(vm.mainData, e.columnName, value);
            }
          }
        });
      });
    },
    // 选部门点击事件
    selectQuerters (column) {
      if (!this.formColumnReadOnly(column)) {
        this.selectQuertersModels.isShow = true;
        this.selectQuertersModels.form = column;
        let selectList = [];
        if (typeof this.mainData[column.columnName] === 'object') {
          selectList = this.mainData[column.columnName];
        } else {
          if (column.widgetType == 'select-depart' || column.widgetType == 'select-depart-multi') {
            let ids = this.mainData[column.columnName];
            let labels = this.mainData[column.columnName + 'LABEL_'];
            if (this.validUtil.isNotNull(ids)) {
              let idArr = ids.split(',');
              let labelArr = labels.split(',');
              idArr.forEach((id, index) => {
                selectList.push({
                  id: id,
                  label: labelArr[index],
                  departName: labelArr[index]
                });
              });
            }
          }
        }
        this.selectQuertersModels.selectList = selectList;
        this.selectQuertersModels.radioSelectFlags = (column.widgetType === 'select-depart');
      }
    },
    // 选部门回调函数
    quertersCallBack () {
      // debugger
      var vm = this;
      if (this.selectQuertersModels.selectList.length === 0) {
        this.util.warn('请至少选择一个部门！');
        return false;
      }
      this.selectQuerters.isShow = false;
      let e = this.formColumnsMap[this.selectQuertersModels.form.columnName];
      if (this.selectQuertersModels.form.widgetType === 'select-depart') {
        vm.$set(vm.mainData, e.columnName + 'LABEL_', this.selectQuertersModels.selectList[0].label);
        vm.$set(vm.mainData, e.columnName, this.selectQuertersModels.selectList[0].id);
        if (e.columnName.lastIndexOf('UID_') > -1) {
          let name = e.columnName.split('UID_');
          vm.$set(vm.mainData, name[0] + 'NAME_', this.selectQuertersModels.selectList[0].label);
        }
        if (e.columnName.lastIndexOf('ID_') > -1) {
          let name = e.columnName.split('ID_');
          vm.$set(vm.mainData, name[0] + 'NAME_', this.selectQuertersModels.selectList[0].label);
        }
      } else if (this.selectQuertersModels.form.widgetType === 'select-depart-multi') {
        // eslint-disable-next-line no-unused-vars
        var labels = '';
        var ids = '';
        this.selectQuertersModels.selectList.forEach(element => {
          labels += (element.label || element.departName) + ',';
          ids += element.id + ',';
        });
        vm.$set(vm.mainData, e.columnName + 'LABEL_', labels.substring(0, labels.length - 1));
        vm.$set(vm.mainData, e.columnName, ids.substring(0, ids.length - 1));

        if (e.columnName.lastIndexOf('UID_') > -1) {
          let name = e.columnName.split('UID_');
          vm.$set(vm.mainData, name[0] + 'NAME_', labels.substring(0, labels.length - 1));
        }
        if (e.columnName.lastIndexOf('ID_') > -1) {
          let name = e.columnName.split('ID_');
          vm.$set(vm.mainData, name[0] + 'NAME_', labels.substring(0, labels.length - 1));
        }
      } else if (this.selectQuertersModels.form.widgetType === 'select-depart-list') {
        var value = [];
        let attr = this.selectQuertersModels.form.attr;
        this.selectQuertersModels.selectList.forEach(i => {
          // debugger;
          let item = {...i};
          delete item.children;
          delete item.parents;
          delete item.parent;
          // let item = {id:i.id,label:i.label,departName:i.label};
          // console.log('-------',item);
          if (attr && attr.indexOf(',') > -1) {
            // 说明是直接写死类型
            let options = attr.split(';');
            options.forEach(item => {
              let option = item.split(',');
              // 存入键值对
              if (item[option[1]]) {
                item[option[0]] = item[option[1]];
              }
            });
          } else {
            // 多选组件编辑时初始化渲染的时候，label没有赋值的话有可能是空
            let label = (item.label || item.departName);
            item.departName = label;
            item.DEPART_NAME_ = label;
            item.DEPART_UID_ = item.id;
          }
          value.push(item);
          vm.$set(vm.mainData, e.columnName, value);
        });
      }
      vm._handlerValueChange(e, vm.mainData[e.columnName]);
      vm.$refs['mainForm'].validateField([e.columnName], (error) => {
        console.log('--validateField-error---', error);
      });
    },
    computeInitValue (column, mainData) { // 表单新增初始化计算初始值
      // console.info(column)
      // console.log('------computeInitValue------',column,column.sourceType);
      if (column.sourceType === 'current-user-uid') {
        if (column.widgetType && column.widgetType === 'select-user') {
          mainData[column.columnName] = this.sessionUtil.getUserUid();
          mainData[column.columnName + 'LABEL_'] = this.sessionUtil.getUserName();
        } else {
          mainData[column.columnName] = this.sessionUtil.getUserUid();
        }
      } else if (column.sourceType === 'current-user-id') {
        mainData[column.columnName] = this.sessionUtil.getUserId();
      } else if (column.sourceType === 'current-user-name') {
        mainData[column.columnName] = this.sessionUtil.getUserName();
      } else if (column.sourceType === 'current-depart-uid') {
        if (column.widgetType && column.widgetType === 'select-depart') {
          mainData[column.columnName] = this.sessionUtil.getDepartUid();
          mainData[column.columnName + 'LABEL_'] = this.sessionUtil.getDepartName();
        } else {
          mainData[column.columnName] = this.sessionUtil.getDepartUid();
        }
      } else if (column.sourceType === 'current-depart-id') {
        mainData[column.columnName] = this.sessionUtil.getDepartId();
      } else if (column.sourceType === 'current-depart-name') {
        mainData[column.columnName] = this.sessionUtil.getDepartName();
      } else if (column.sourceType === 'current-position-id') {
        mainData[column.columnName] = this.sessionUtil.getPositionId();
      } else if (column.sourceType === 'current-position-name') {
        mainData[column.columnName] = this.sessionUtil.getPositionName();
      } else if (column.sourceType === 'current-sub-company-uid') {

        mainData[column.columnName] = this.sessionUtil.getSubCompanyUid();
      } else if (column.sourceType === 'current-sub-company-name') {
        mainData[column.columnName] = this.sessionUtil.getSubCompanyName();
      }else if (column.sourceType === 'current-company-uid') {
        if (column.widgetType && column.widgetType === 'select-depart') {
          mainData[column.columnName] = this.sessionUtil.getCompanyUid();
          mainData[column.columnName + 'LABEL_'] = this.sessionUtil.getCompanyName();
        } else {
          mainData[column.columnName] = this.sessionUtil.getCompanyUid();
        }
      } else if (column.sourceType === 'current-company-id') {
        mainData[column.columnName] = this.sessionUtil.getCompanyId();
      } else if (column.sourceType === 'current-company-name') {
        mainData[column.columnName] = this.sessionUtil.getCompanyName();
      } else if (column.sourceType === 'current-date') {
        mainData[column.columnName] = (new Date()).format('yyyy-MM-dd');
        // mainData[column.columnName] = new Date()
      } else if (column.sourceType === 'current-year') {
        mainData[column.columnName] = (new Date()).format('yyyy');
        // mainData[column.columnName] = new Date()
      } else if (column.sourceType === 'current-month') {
        mainData[column.columnName] = (new Date().getMonth() + 1).toString();
        // mainData[column.columnName] = new Date()
      } else if (column.sourceType === 'current-month-long') {
        mainData[column.columnName] = this.util.numPadStart((new Date().getMonth() + 1),2);
        // mainData[column.columnName] = new Date()
      } else if (column.sourceType === 'current-datetime') {
        // mainData[column.columnName] = new Date()
        mainData[column.columnName] = (new Date()).format('yyyy-MM-dd hh:mm:ss');
      } else if (column.sourceType === 'current-year') {
        mainData[column.columnName] = new Date().getFullYear();
      } else if (column.sourceType === 'current-quarter') {
        var month = new Date().getMonth();
        var currQuarter = 1;
        if (month < 3) {
          currQuarter = 1;
        } else if (month < 6) {
          currQuarter = 2;
        } else if (month < 9) {
          currQuarter = 3;
        } else if (month < 12) {
          currQuarter = 4;
        }
        mainData[column.columnName] = currQuarter;
      } else if (column.sourceType === 'current-month') {
        mainData[column.columnName] = new Date().getMonth() + 1;
      } else if (column.sourceType === 'current-week') {
        mainData[column.columnName] = this.util.getYearWeek();
      } else if (column.sourceType === 'current-next-monday') { // 下周一
        mainData[column.columnName] = this.util.getNextMonday();
      } else if (column.sourceType === 'current-month-first') { // 本月第一天
        mainData[column.columnName] = this.util.getCurrentMonthFirst();
      } else if (column.sourceType === 'current-month-last') { // 本月最后一天
        mainData[column.columnName] = this.util.getCurrentMonthLast();
      } else if (column.sourceType === 'next-month-first') { // 本月第一天
        mainData[column.columnName] = this.util.getNextMonthFirst();
      } else if (column.sourceType === 'UUID') { //
        mainData[column.columnName] = getUUID();
      } else if (column.sourceType === 'next-month-last') { // 本月最后一天
        mainData[column.columnName] = this.util.getNextMonthLast();
      }
      // console.log(column.columnName+'-----------'+mainData[column.columnName])
    },
    getConstValue (key) { // 根据key获取常量值
      return this.sessionUtil.getConstValue(this, key);
    },
    openLinkedForm (column) { // 表单穿透
      let businessKey = this.mainData[column.columnName];
      if (this.validUtil.isNotNull(column.linked.businessKey)) {
        let str = column.linked.businessKey;
        if (str.indexOf('{') > -1) {
          let key = str.substring(str.indexOf('{') + 1, str.indexOf('}'));
          businessKey = this.mainData[key];
        }
      }

      this.selectFormConfig = {
        formKey: column.linked.formKey,
        readOnly: true,
        disabled: true,
        parent: this,
        businessKey: businessKey
      };
      this.formDialogVisible = true;
    },
    setEditorData(column,html){
      let key = column.columnName;
      let editor = this.$refs['full-editor-'+key];
      let baseUrl = this.util.getBaseUrl();
      html = html.replaceAll('src="share/temp','src="'+baseUrl+'/share/temp');
      html = html.replaceAll('src="share/','src="'+baseUrl+'/share/');
      html = html.replaceAll('src="/share/','src="'+baseUrl+'/share/');
      this.mainData[key] = html;
      // console.log(editor,'------setEditorData----',column,html);
      if(editor) {

        editor[0].setContent(html);
      }
    },
    getEditorData(column){
      let editor = this.$refs['full-editor-'+column.columnName];
      if(editor && editor[0]) {
        let html = editor[0].getContent();
        return html;
      }
      return this.mainData[column.columnName];
    },
    closeOpenDialog () { // 用于穿透弹框表单点击关闭
      this.formDialogVisible = false;
    },
    compare(prop) {
      return function (obj1, obj2) {
          var val1 = obj1[prop];
          var val2 = obj2[prop];
          if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
              val1 = Number(val1);
              val2 = Number(val2);
          }
          if (val1 < val2) {
              return -1;
          } else if (val1 > val2) {
              return 1;
          } else {
              return 0;
          }            
      } 
  }
  }
};



// WEBPACK FOOTER //
// ./src/common/form/form-edit/mixin.js